export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Datetime: any;
  Decimal: any;
  URL: any;
  Colour: any;
};


/** An organisation which groups Contacts together */
export type Account = {
  __typename?: 'Account';
  /** A list of Account ancestors for this account */
  ancestors: Array<AccountAncestor>;
  /** ID of the Account */
  id: Scalars['ID'];
  /** Name of the Account */
  name: Scalars['String'];
};

/** An Account Ancestor */
export type AccountAncestor = {
  __typename?: 'AccountAncestor';
  /** ID of the Account Ancestor */
  id: Scalars['ID'];
  /** Name of the Account Ancestor */
  name: Scalars['String'];
};

/** A paginated Account list related to the Node */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** The paginated list of relationships */
  edges: Array<AccountEdge>;
  /** Information regarding the pagination of the list */
  pageInfo: PageInfo;
};

/** an Edge type describes the connection between the node and its parent */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor: Scalars['String'];
  /** The Account involved in the relationship */
  node: Account;
};

/** Fields for filtering and ordering an Account list */
export enum AccountField {
  /** The ID of the Account */
  Id = 'id',
  /** The name of the Account */
  Name = 'name'
}

/** Used to filter an Account List */
export type AccountFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<AccountField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type AccountFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<AccountField>;
};

/** An Achievement */
export type Achievement = Node & {
  __typename?: 'Achievement';
  /** The date and time this Achievement was created */
  achievedAt?: Maybe<Scalars['Datetime']>;
  /** The Achievement Type linked to the Achievement */
  achievementType?: Maybe<AchievementType>;
  /** URL to the Certificate */
  certificateUrl?: Maybe<Scalars['String']>;
  /** List of Document IDs */
  documentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** List of Document URLs */
  documentUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The date this Achievement expires */
  expiresAt?: Maybe<Scalars['Datetime']>;
  /** The ID of the Achievement */
  id: Scalars['ID'];
  /** The string identifier of the Achievement */
  identifier?: Maybe<Scalars['String']>;
  /** The Lifecycle State of the Achievement */
  lifecycleState?: Maybe<AchievementState>;
  /** The Registerable associated to the Achievement */
  registerable?: Maybe<Registerable>;
};

/** A paginated Achievement list related to the Node */
export type AchievementConnection = {
  __typename?: 'AchievementConnection';
  /** The paginated list of relationships */
  edges: Array<AchievementEdge>;
  /** Information regarding the pagination of the list */
  pageInfo: PageInfo;
};

/** an Edge type describes the connection between the node and its parent */
export type AchievementEdge = {
  __typename?: 'AchievementEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor: Scalars['String'];
  /** The Achievement involved in the relationship */
  node: Achievement;
};

/** Fields for filtering and ordering an Achievement list */
export enum AchievementField {
  /** The name of the Achievement Type linked to the Achievement */
  AchievementTypeName = 'achievementTypeName',
  /** The date this Achievement expires */
  ExpiresAt = 'expiresAt',
  /** The ID of the Achievement */
  Id = 'id'
}

/** Used to filter an Achievement List */
export type AchievementFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<AchievementField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type AchievementFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<AchievementField>;
};

/** Count of Achievements */
export type AchievementsCount = {
  __typename?: 'AchievementsCount';
  /** Count of Achievements */
  count?: Maybe<Scalars['Int']>;
};

/** State of an Achievement */
export enum AchievementState {
  /** Active Achievement */
  Active = 'active',
  /** Expired Achievement */
  Expired = 'expired',
  /** Revoked Achievement */
  Revoked = 'revoked'
}

/** An Achievement Type */
export type AchievementType = Node & {
  __typename?: 'AchievementType';
  /** The Certificate Type associated with the Achievment Type */
  certificateType?: Maybe<CertificateType>;
  /** The ID of the Achievement Type */
  id?: Maybe<Scalars['ID']>;
  /** The name given to the Achievement Type */
  name?: Maybe<Scalars['String']>;
};

/** An input to associate Contacts with an Unnamed Learner */
export type AssociateUnnamedLearnerWithContactsInput = {
  /** A list of Contact IDs to associate this Registration with */
  contactIds: Array<Scalars['ID']>;
  /** The ID of the Unnamed Learner with which to associate the Contacts */
  registrationId: Scalars['ID'];
};

/** A response from associating an Unnamed Learner with Contacts */
export type AssociateUnnamedLearnerWithContactsResponseType = {
  __typename?: 'AssociateUnnamedLearnerWithContactsResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registrations that were associated with existing Contacts */
  registrations?: Maybe<Array<Maybe<Registration>>>;
};

/** An Attempt */
export type Attempt = {
  __typename?: 'Attempt';
  /** Any accompanying documentation on the Attempt */
  accompanyingDocumentation?: Maybe<Scalars['String']>;
  /** The Attempts Content */
  content: ExternalContentResult;
  /** ID of the Attempt */
  id: Scalars['ID'];
  /** Registration linked to the Attempt */
  registration: Registration;
};

/** A Response from mutating an Attempt */
export type AttemptMutateResponseType = {
  __typename?: 'AttemptMutateResponseType';
  /** The Attempt that was mutated */
  attempt?: Maybe<Attempt>;
  /** The errors returned by the mutation */
  errors: Array<FieldError>;
};

/** Attempt Mutations */
export type AttemptMutations = {
  __typename?: 'AttemptMutations';
  /** Mutations for Attempts */
  recordExternalProgress?: Maybe<AttemptMutateResponseType>;
};


/** Attempt Mutations */
export type AttemptMutationsRecordExternalProgressArgs = {
  input?: Maybe<RecordExternalProgressInput>;
};

/** An input for recording a SCORM attempt */
export type AttemptScormContentInput = {
  /** The ID of the SCORM Content being attempted */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Registration attempting the SCORM Content */
  registrationId?: Maybe<Scalars['ID']>;
};

/** Details about a learners attendance */
export type Attendance = {
  __typename?: 'Attendance';
  /** A summary of sessiosn for this Learner */
  sessionDetail?: Maybe<SessionDetailConnection>;
  /** The number of sessions the Learner has attended */
  sessionsAttended?: Maybe<Scalars['Int']>;
  /** The number of sessions the Learner has missed */
  sessionsMissed?: Maybe<Scalars['Int']>;
  /** The total number of sessions for this Learner */
  totalSessions?: Maybe<Scalars['Int']>;
};

/** A Contact facing identity used with Portals such as LMS and Weblink */
export type Brand = {
  __typename?: 'Brand';
  /** The elements used to define this Brand's visual identity */
  branding?: Maybe<Branding>;
  /** The ID of this Brand */
  id?: Maybe<Scalars['ID']>;
  /** The name of this Brand */
  name?: Maybe<Scalars['String']>;
  /** Indicates if Contacts can log into this Portal only by Single Sign On */
  singleSignOnOnly: Scalars['Boolean'];
  /** A Welcome Message associated to this Brand */
  welcomeMessage?: Maybe<WelcomeMessage>;
};

/** A collection of elements used to define a Brand's visual identity */
export type Branding = {
  __typename?: 'Branding';
  /** The Button options used by this Branding */
  buttons?: Maybe<BrandingButtons>;
  /** The Colours used by this Branding */
  colours?: Maybe<BrandingColours>;
  /** The Images used by this Branding */
  images?: Maybe<BrandingImages>;
};

/** Settings that define Branding Buttons */
export type BrandingButtons = {
  __typename?: 'BrandingButtons';
  /** The border radius on Buttons that have this Branding applied */
  borderRadius?: Maybe<Scalars['String']>;
};

/** A collection of Colours that are part of a Branding */
export type BrandingColours = {
  __typename?: 'BrandingColours';
  /** The text Color used on color branded backgrounds like title bars */
  contrastText?: Maybe<Scalars['Colour']>;
  /** The text Color used on light backgrounds like the Course description and Event lists */
  mainText?: Maybe<Scalars['Colour']>;
  /** The Background Color used on Page Navigation Bars */
  navigationBackground?: Maybe<Scalars['Colour']>;
  /** The text Color used on buttons within the Navigation Bar */
  navigationButtonText?: Maybe<Scalars['Colour']>;
  /** The primary Branding Color used as a highlight and selection Colour */
  primary?: Maybe<Scalars['Colour']>;
  /** The background Color used on primary actions, like the checkout button */
  primaryActionButton?: Maybe<Scalars['Colour']>;
  /** The text Color used on primary actions, like the checkout button */
  primaryActionButtonText?: Maybe<Scalars['Colour']>;
  /** The secondary Branding Color */
  secondary?: Maybe<Scalars['Colour']>;
  /** The background Color used on secondary actions, like the cancel button */
  secondaryActionButton?: Maybe<Scalars['Colour']>;
  /** The text Color used on secondary actions, like the cancel button */
  secondaryActionButtonText?: Maybe<Scalars['Colour']>;
};

/** Settings that define a Branding Image */
export type BrandingImage = {
  __typename?: 'BrandingImage';
  /** The URL of the image */
  imageUrl?: Maybe<Scalars['String']>;
};

/** A collection of Images that are part of a Branding */
export type BrandingImages = {
  __typename?: 'BrandingImages';
  /** The favicon Image displayed in browser tabs that have this Branding applied */
  favicon?: Maybe<BrandingImage>;
};

/** A cancellation Reason */
export type CancellationReason = Node & {
  __typename?: 'CancellationReason';
  /** The ID of the Cancellation Reason */
  id?: Maybe<Scalars['ID']>;
  /** The Text for the Cancellation Reason */
  text?: Maybe<Scalars['String']>;
};

/** A paginated CancellationReason list related to the Node */
export type CancellationReasonConnection = {
  __typename?: 'CancellationReasonConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<CancellationReasonEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type CancellationReasonEdge = {
  __typename?: 'CancellationReasonEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Cancellation Reason involved in the relationship */
  node?: Maybe<CancellationReason>;
};

/** Fields for filtering and ordering a CancellationReason list */
export enum CancellationReasonField {
  /** The ID of the Cancellation Reason */
  Id = 'id'
}

/** Used to filter a CancellationReason List */
export type CancellationReasonFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<CancellationReasonField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type CancellationReasonFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<CancellationReasonField>;
};

/** A cancellation request */
export type CancellationRequest = Node & {
  __typename?: 'CancellationRequest';
  /** The Approval State of the Cancellation Request */
  approvalState?: Maybe<Scalars['String']>;
  /** When the Cancellation Request was created */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The Event on the Cancellation Request */
  event?: Maybe<Event>;
  /** The ID of the Cancellation Request */
  id?: Maybe<Scalars['ID']>;
  /** The Learner linked to the Cancellation Request */
  learner?: Maybe<Scalars['String']>;
  /** The Reason for the Cancellation Request */
  reason?: Maybe<Scalars['String']>;
  /** The note that accompanies the above Reason for the Cancellation Request */
  reasonNotes?: Maybe<Scalars['String']>;
  /** Registerable ID */
  registerableId?: Maybe<Scalars['ID']>;
  /** The last time the Cancellation Request was updated */
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** A paginated CancellationRequest list related to the Node */
export type CancellationRequestConnection = {
  __typename?: 'CancellationRequestConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<CancellationRequestEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type CancellationRequestEdge = {
  __typename?: 'CancellationRequestEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Cancellation Request involved in the relationship */
  node?: Maybe<CancellationRequest>;
};

/** Fields for filtering and ordering a CancellationRequest list */
export enum CancellationRequestField {
  /** The Approval State of the Cancellation Request */
  ApprovalState = 'approvalState',
  /** The ID of the Brand of the Cancellation Request */
  BrandId = 'brandId',
  /** The ID of the Contact requesting the cancellation */
  ContactId = 'contactId',
  /** The ID of the Cancellation Request */
  Id = 'id'
}

/** Used to filter a CancellationRequest List */
export type CancellationRequestFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<CancellationRequestField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type CancellationRequestFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<CancellationRequestField>;
};

/** Mutations available for Cancellation Request */
export type CancellationRequestMutations = {
  __typename?: 'CancellationRequestMutations';
  /** Creates a Cancellation Request */
  create?: Maybe<CreateCancellationRequestMutationResponseType>;
};


/** Mutations available for Cancellation Request */
export type CancellationRequestMutationsCreateArgs = {
  input?: Maybe<CreateCancellationRequestInputType>;
};

/** A paginated Catalogue list related to the Node */
export type CatalogueConnection = {
  __typename?: 'CatalogueConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<CatalogueEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type CatalogueEdge = {
  __typename?: 'CatalogueEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Catalogue Item involved in the relationship */
  node?: Maybe<CatalogueItem>;
};

/** Fields for filtering and ordering a Catalogue list */
export enum CatalogueField {
  /** The ID of the Catalogue Item */
  Id = 'id',
  /** The ID of a Category to which the Catalogue Item belongs */
  LearningCategoryId = 'learningCategoryId',
  /** The name of the Catalogue Item */
  Name = 'name',
  /** The type of training the Catalogue Item represents */
  Type = 'type'
}

/** Used to filter a Catalogue List */
export type CatalogueFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<CatalogueField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type CatalogueFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<CatalogueField>;
};

/** A thing that is available to be sold */
export type CatalogueItem = {
  __typename?: 'CatalogueItem';
  /** Category */
  category?: Maybe<Category>;
  /** Code */
  code?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** FAQs */
  faqs?: Maybe<Scalars['String']>;
  /** The ID of the Catalogue Item */
  id?: Maybe<Scalars['ID']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** The name of the Catalogue Item */
  name?: Maybe<Scalars['String']>;
  /** Outcomes */
  outcomes?: Maybe<Scalars['String']>;
  /** Prerequisites */
  prerequisites?: Maybe<Scalars['String']>;
  /** Teaser Description */
  teaserDescription?: Maybe<Scalars['String']>;
  /** Topics Covered */
  topicsCovered?: Maybe<Scalars['String']>;
};

/** A Category for Courses and Learning Paths */
export type Category = {
  __typename?: 'Category';
  /** ID for the Category */
  id?: Maybe<Scalars['ID']>;
  /** Name for the Category */
  name?: Maybe<Scalars['String']>;
  /** A list of Subcategories for the Category */
  subcategories?: Maybe<SubcategoryConnection>;
};

/** A paginated Cateogry list related to the Node */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<CategoryEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** The Category involved in the relationship */
  node?: Maybe<Category>;
};

/** A Certificate Type */
export type CertificateType = Node & {
  __typename?: 'CertificateType';
  /** The ID of the Certificate Type */
  id: Scalars['ID'];
  /** The name of the Certificate Type */
  name: Scalars['String'];
};


/** Comment made by a Learner on LMS content */
export type Comment = {
  __typename?: 'Comment';
  /** The text of the Comment */
  comment: Scalars['String'];
  /** The Contact for the user that created the Comment */
  contact: Contact;
  /** The Date and Time the Comment was created */
  createdAt: Scalars['Datetime'];
  /** The Document ID */
  id: Scalars['ID'];
};

/** A paginated Comment list related to the Node */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** The paginated list of relationships */
  edges: Array<CommentEdge>;
  /** Information regarding the pagination of the list */
  pageInfo: PageInfo;
};

/** an Edge type describes the connection between the node and its parent */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor: Scalars['String'];
  /** The Comment involved in the relationship */
  node: Comment;
};

/** Fields for filtering and ordering a Comment list */
export enum CommentField {
  /** The text of the Comment */
  Comment = 'comment',
  /** The Date and Time the Comment was created */
  CreatedAt = 'createdAt'
}

/** Used to filter a Comment List */
export type CommentFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<CommentField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type CommentFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<CommentField>;
};

/** A person/individual */
export type Contact = {
  __typename?: 'Contact';
  /** Primary Account the Contact belongs to */
  account: Account;
  /** Custom Field Values for the Account */
  customFieldValues?: Maybe<Array<Maybe<ContactCustomFieldValue>>>;
  /** The department of the Contact */
  department?: Maybe<Scalars['String']>;
  /** Primary email address of the Contact */
  emailAddress?: Maybe<Scalars['String']>;
  /** The fax phone number of the Contact */
  faxPhoneNumber?: Maybe<Scalars['String']>;
  /** The first name of the Contact */
  firstName: Scalars['String'];
  /** The home phone number of the Contact */
  homePhoneNumber?: Maybe<Scalars['String']>;
  /** ID of the Contact */
  id: Scalars['ID'];
  /** A coordinator for any Account */
  isCoordinator: Scalars['Boolean'];
  /** A coordinator managing at least one Account the current Viewer manages */
  isOverlappingCoordinator: Scalars['Boolean'];
  /** The job role of the Contact */
  jobRole?: Maybe<Scalars['String']>;
  /** The last name of the Contact */
  lastName: Scalars['String'];
  /** Learning Path Registrations for the Contact */
  learningPathRegistrations: LearningPathRegistrationConnection;
  /** The Accounts the Contact is responsible for */
  managedAccounts: AccountConnection;
  /** The mobile phone number of the Contact */
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  /** The office phone number for the Contact */
  officePhoneNumber?: Maybe<Scalars['String']>;
  /** The list of Phone Numbers for the Account */
  phoneNumbers?: Maybe<Array<Maybe<ContactPhoneNumber>>>;
  /** Postal Address of the Contact */
  postalAddress?: Maybe<PostalAddress>;
  /** Registrations for the Contact */
  registrations: RegistrationConnection;
};


/** A person/individual */
export type ContactLearningPathRegistrationsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<LearningPathRegistrationFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<LearningPathRegistrationFieldOrder>;
};


/** A person/individual */
export type ContactManagedAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<AccountFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<AccountFieldOrder>;
};


/** A person/individual */
export type ContactRegistrationsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<RegistrationFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<RegistrationFieldOrder>;
};

/** A paginated Contact list related to the Node */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** The paginated list of relationships */
  edges: Array<ContactEdge>;
  /** Information regarding the pagination of the list */
  pageInfo: PageInfo;
};

/** An input to make or revoke a Contact a Coordinator for specific accounts */
export type ContactCoordinatorInput = {
  /** The Account IDs being added or removed */
  accountIds?: Maybe<Array<Scalars['ID']>>;
  /** The Contact ID of the Coordinator */
  contactId: Scalars['ID'];
};

/** An input for creating a Contact */
export type ContactCreateInput = {
  /** The account ID that the Contact belongs to */
  accountId: Scalars['ID'];
  /** The list of Email Addresses of the Contact */
  emailAddresses?: Maybe<Array<Maybe<ContactEmailAddressesInputType>>>;
  /** The job role of the Contact */
  jobRole?: Maybe<Scalars['String']>;
  /** The personal name of the Contact */
  personalName: PersonalNameInputType;
  /** The list of Phone Numbers of the Contact */
  phoneNumbers?: Maybe<Array<Maybe<ContactPhoneNumberInputType>>>;
  /** The postal address of the Contact */
  postalAddress?: Maybe<PostalAddressInput>;
};

/** The custom field set in System */
export type ContactCustomFieldValue = {
  __typename?: 'ContactCustomFieldValue';
  /** The identifier of the Custom Field Definition */
  definitionKey?: Maybe<Scalars['String']>;
  /** The value stored */
  value?: Maybe<Scalars['String']>;
};

/** an Edge type describes the connection between the node and its parent */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor: Scalars['String'];
  /** The Contact involved in the relationship */
  node: Contact;
};

/** An input for an email address of a Contact */
export type ContactEmailAddressesInputType = {
  /** The email address */
  address?: Maybe<Scalars['String']>;
  /** The ContactEmailAddressUsage of the Email Address being mutated */
  usage?: Maybe<ContactEmailAddressUsage>;
};

/** The usages of an email address on a Contact */
export enum ContactEmailAddressUsage {
  /** The primary email address for the Contact */
  Primary = 'primary',
  /** The secondary email address for the Contact */
  Secondary = 'secondary'
}

/** Fields for filtering and ordering a Contact list */
export enum ContactField {
  /** The ID of the Primary Account to which the Contact belongs */
  AccountId = 'accountId',
  /** The primary email address of the Contact */
  EmailAddress = 'emailAddress',
  /** The first name of the Contact */
  FirstName = 'firstName',
  /** The ID of the Contact */
  Id = 'id',
  /** Denotes if the Contact is a Coordinator for any Account */
  IsCoordinator = 'isCoordinator',
  /** Denotes if the Contact coordinates at least one Account that the current Viewer also coordinates */
  IsOverlappingCoordinator = 'isOverlappingCoordinator',
  /** The last name of the Contact */
  LastName = 'lastName',
  /** The full name of the Contact */
  Name = 'name'
}

/** Used to filter a Contact List */
export type ContactFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<ContactField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type ContactFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<ContactField>;
};

/** A response from mutating a Contact */
export type ContactMutateResponseType = {
  __typename?: 'ContactMutateResponseType';
  /** The Contact that was mutated */
  contact?: Maybe<Contact>;
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
};

/** Mutations for Contacts */
export type ContactMutations = {
  __typename?: 'ContactMutations';
  /** Creates a Contact */
  create?: Maybe<ContactMutateResponseType>;
  /** Makes a Contact a Coordinator for the supplied Accounts */
  makeCoordinatorForAccounts?: Maybe<ContactMutateResponseType>;
  /** Revoke Coordinator rights for a Contact for the supplied Accounts */
  revokeCoordinatorForAccounts?: Maybe<ContactMutateResponseType>;
  /** Updates the Contact */
  update?: Maybe<ContactMutateResponseType>;
};


/** Mutations for Contacts */
export type ContactMutationsCreateArgs = {
  input?: Maybe<ContactCreateInput>;
};


/** Mutations for Contacts */
export type ContactMutationsMakeCoordinatorForAccountsArgs = {
  input?: Maybe<ContactCoordinatorInput>;
};


/** Mutations for Contacts */
export type ContactMutationsRevokeCoordinatorForAccountsArgs = {
  input?: Maybe<ContactCoordinatorInput>;
};


/** Mutations for Contacts */
export type ContactMutationsUpdateArgs = {
  input?: Maybe<ContactUpdateInput>;
};

/** A Phone Number for a Contact */
export type ContactPhoneNumber = {
  __typename?: 'ContactPhoneNumber';
  /** The phone number */
  number?: Maybe<Scalars['String']>;
  /** The usage of the phone number */
  usage?: Maybe<ContactPhoneNumberUsage>;
};

/** An input for a phone number for a Contact */
export type ContactPhoneNumberInputType = {
  /** The phone number */
  number?: Maybe<Scalars['String']>;
  /** The ContactPhoneNumberUsage of the PhoneNumber being mutated */
  usage?: Maybe<ContactPhoneNumberUsage>;
};

/** Contact Phone Number Usage */
export enum ContactPhoneNumberUsage {
  /** A phone number to be used for faxing */
  Fax = 'fax',
  /** A phone number for the Contact's home */
  Home = 'home',
  /** A phone number for the Contact's mobile/cell phone */
  Mobile = 'mobile',
  /** A phone number for the Contact's office */
  Office = 'office'
}

/** An input for updating a Contact */
export type ContactUpdateInput = {
  /** The accountID for this Contact */
  accountId?: Maybe<Scalars['ID']>;
  /** The ID of the Contact being updated */
  contactId: Scalars['ID'];
  /** The new job role of the Contact */
  jobRole?: Maybe<Scalars['String']>;
  /** New Personal Name */
  personalName?: Maybe<PersonalNameInputType>;
  /** The list of Phone Numbers of the Contact being added or updated */
  phoneNumbers?: Maybe<Array<Maybe<ContactPhoneNumberInputType>>>;
  /** The postal address of the Contact */
  postalAddress?: Maybe<PostalAddressInput>;
};

/** Substantive information or creative material to aid training */
export type Content = {
  /** Flag indicating if the content should be auto completed on learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the content */
  displayName?: Maybe<Scalars['String']>;
  /** Optional description of Content. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the Content */
  id?: Maybe<Scalars['ID']>;
  /** List of Training Pass Type IDs that grant access to this content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** If the content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** Type of Content */
  type?: Maybe<Scalars['String']>;
};

/** Content and Registration */
export type ContentAndRegistration = {
  __typename?: 'ContentAndRegistration';
  /** The details of the Content */
  content?: Maybe<Content>;
  /** The details of the Registration */
  registration?: Maybe<RegistrationDetails>;
};

/** A paginated Content list related to the Node */
export type ContentConnection = {
  __typename?: 'ContentConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<ContentEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Content involved in the relationship */
  node?: Maybe<Content>;
};

/** A Result for a Learner on a piece of Content */
export type ContentResult = {
  /** The attempts on this Content */
  attempts?: Maybe<Scalars['Int']>;
  /** The number of completed attempts the Learner has had on this Content */
  completedAttempts?: Maybe<Scalars['Int']>;
  /** The Content this result relates to */
  content?: Maybe<Content>;
  /** The ID to the piece of Content this result relates to */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the ContentResult */
  id?: Maybe<Scalars['ID']>;
  /** The date and time when the Content was last accessed */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The percentage complete the Learner has achieved on the Content */
  progress?: Maybe<Scalars['Decimal']>;
  /** The score the Learner has achieved on the Content */
  score?: Maybe<Scalars['Decimal']>;
  /** The score percent the Learner has achieved on the Content */
  scorePercent?: Maybe<Scalars['Decimal']>;
  /** The current status of the Content */
  status?: Maybe<ContentResultStatus>;
};

/** A paginated ContentResult list related to the Node */
export type ContentResultConnection = {
  __typename?: 'ContentResultConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<ContentResultEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type ContentResultEdge = {
  __typename?: 'ContentResultEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Content Result involved in the relationship */
  node?: Maybe<ContentResult>;
};

/** Fields for filtering and ordering a ContentResult list */
export enum ContentResultField {
  /** The ID to the piece of Content this result relates to */
  ContentId = 'contentId'
}

/** Used to filter a ContentResult List */
export type ContentResultFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<ContentResultField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type ContentResultFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<ContentResultField>;
};

/** Statuses for Content Results */
export enum ContentResultStatus {
  /** The Content was completed */
  Completed = 'completed',
  /** The Content has been downloaded */
  Downloaded = 'downloaded',
  /** The Content was failed */
  Failed = 'failed',
  /** The Content has not been completed */
  Incomplete = 'incomplete',
  /** The Content was passed */
  Passed = 'passed'
}

/** A nation with a designated ISO country code */
export type Country = {
  __typename?: 'Country';
  /** ISO designated country code */
  code?: Maybe<Scalars['String']>;
  /** The ID of the Country */
  id?: Maybe<Scalars['ID']>;
  /** Name of the Country */
  name?: Maybe<Scalars['String']>;
};

/** The instance of training at a set time and location */
export type Course = Node & {
  __typename?: 'Course';
  /** The number of days the self-paced Course is accessible for */
  accessDuration?: Maybe<Scalars['Int']>;
  /**
   * @deprecated |||
   * |-|-:|
   * | Reason | This field is no longer used. Please use "achievementTypes". |
   * | Removal Date | 2025-07-21 |
   * | Deprecation Date | 2025-04-21 |
   */
  achievementType?: Maybe<AchievementType>;
  /** The Achievement Types for this Course */
  achievementTypes?: Maybe<Array<Maybe<AchievementType>>>;
  /** The number of missed sessions a Learner is allowed to qualify as Passed upon Event completion */
  allowedMissedSessions?: Maybe<Scalars['Int']>;
  /** Categories the Course is in */
  categories?: Maybe<CategoryConnection>;
  /** Course Code */
  code?: Maybe<Scalars['String']>;
  /** Content that belongs to the Course */
  content?: Maybe<ContentConnection>;
  /** Documents mapped to this Course */
  documents: Array<DmsDocument>;
  /** The date and time the Course ends */
  end?: Maybe<Scalars['Datetime']>;
  /** The date the Course ends */
  endDate?: Maybe<Scalars['Datetime']>;
  /** ID of the Course */
  id: Scalars['ID'];
  /** URL for the Course Image */
  imageUrl?: Maybe<Scalars['String']>;
  /** The Instructors for the Event */
  instructors: Array<Instructor>;
  /** The form the training takes for instance classroom or blended */
  learningMode?: Maybe<LearningMode>;
  /** The Course LMS Announcements/Notes */
  lmsAnnouncements?: Maybe<Scalars['String']>;
  /** The ending date and time when the LMS access or self paced learning is scheduled to close */
  lmsEnd?: Maybe<Scalars['Datetime']>;
  /** The starting date and time when the LMS access or self paced learning is scheduled to open */
  lmsStart?: Maybe<Scalars['Datetime']>;
  /** Location at which the Course takes place */
  location?: Maybe<Location>;
  /** The message for the Course */
  message?: Maybe<Scalars['String']>;
  /** Number of Learner places remaining on the Course */
  remainingPlaces?: Maybe<Scalars['Int']>;
  /** Resources on the Course */
  resources: Array<CourseResource>;
  /** Sessions that belong to the Course */
  sessions?: Maybe<SessionsConnection>;
  /** The date and time the Course starts */
  start?: Maybe<Scalars['Datetime']>;
  /** The date the Course starts */
  startDate?: Maybe<Scalars['Datetime']>;
  /** Title of the Course */
  title: Scalars['String'];
};


/** The instance of training at a set time and location */
export type CourseContentArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  learnerId?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
};

/** A Course Objective on a Learning Path */
export type CourseObjective = LearningObjective & Node & {
  __typename?: 'CourseObjective';
  /** The Course used for this Objective */
  course?: Maybe<Course>;
  /** The number of Credits that this Learning Objective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The expected required time in days to complete the Learning Objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** ID of the Course Objective */
  id?: Maybe<Scalars['ID']>;
  /** The order of this Learning Objective in the set of Learning Path Objectives */
  order?: Maybe<Scalars['Int']>;
};

/** The Outcome from the Course Objective */
export type CourseOutcome = LearningPathResult & Node & {
  __typename?: 'CourseOutcome';
  /** Denotes whether or not the Outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The Course to which the Outcome refers to */
  course?: Maybe<Course>;
  /** The number of credits that the Outcome represents */
  credits?: Maybe<Scalars['Int']>;
  /** ID for the Course Outcome */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the Objective to which the Outcome refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
  /** Course Outcome Registration ID */
  registrationId?: Maybe<Scalars['ID']>;
};

/** A paginated Registration list to be previewed during Event configuration */
export type CoursePreviewConnection = {
  __typename?: 'CoursePreviewConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<RegistrationEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** A Resource for the Course */
export type CourseResource = {
  __typename?: 'CourseResource';
  /** Label of the Resource */
  label: Scalars['String'];
  /** Link to the Resource */
  link: Scalars['String'];
};

/** An Input to create a Cancellation Request */
export type CreateCancellationRequestInputType = {
  /** ID of the Learner on the Cancellation Request */
  learnerId?: Maybe<Scalars['ID']>;
  /** ID of the Reason why the Cancellation is being Requested */
  reasonId?: Maybe<Scalars['ID']>;
  /** Notes on the Cancellation Reason */
  reasonNotes?: Maybe<Scalars['String']>;
};

/** The response from Creating a Cancellation Request */
export type CreateCancellationRequestMutationResponseType = {
  __typename?: 'CreateCancellationRequestMutationResponseType';
  /** The newly created Cancellation Request */
  cancellationRequest?: Maybe<CancellationRequest>;
  /** Errors from the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
};

/** Create a new Training Request Opportunity */
export type CreateTrainingRequestInputType = {
  /** Point of Sale Field Values */
  pointOfSaleFieldValues?: Maybe<Array<PointOfSaleFieldValueType>>;
  /** Training Request Item ID */
  trainingRequestItemId?: Maybe<Scalars['ID']>;
};

/** An Input for Custom Field Value */
export type CustomFieldValueInputType = {
  /** The identifier for the CustomFieldDefinition of the CustomFieldValue being mutated */
  definitionKey?: Maybe<Scalars['ID']>;
  /** The new value of the CustomFieldValue. Defining this as null will set the value to null */
  value?: Maybe<Scalars['String']>;
};



/** An input for deleting a Discussion Comment */
export type DeleteDiscussionCommentInput = {
  /** The ID of the Discussion Comment to be deleted */
  commentId: Scalars['ID'];
};

/** The form the training takes */
export enum DeliveryMethod {
  /** The training is delivered in part in a classroom, and in part through an LMS */
  Blended = 'blended',
  /** The training is delivered in a classroom */
  Classroom = 'classroom',
  /** The training is delivered through an LMS */
  Lms = 'lms'
}

/**
 * A type of content on an Event that allows Learners to post comments related to
 * the Event which can be seen by other Learners registered to the Event
 */
export type DiscussionTopic = Content & Node & {
  __typename?: 'DiscussionTopic';
  /** Flag indicating if the Content should be auto completed on Learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The Comments posted to the DiscussionTopic */
  comments: CommentConnection;
  /** The main display name of the Content */
  displayName?: Maybe<Scalars['String']>;
  /** The description of the Content. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** The ID of the DiscussionTopic */
  id: Scalars['ID'];
  /** List of Training Pass Type IDs that grant access to this Content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Content should be displayed */
  order: Scalars['Int'];
  /** The Content type */
  type: Scalars['String'];
};


/**
 * A type of content on an Event that allows Learners to post comments related to
 * the Event which can be seen by other Learners registered to the Event
 */
export type DiscussionTopicCommentsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CommentFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<CommentFieldOrder>;
};

/** Document stored in the DMS */
export type DmsDocument = {
  __typename?: 'DmsDocument';
  /** DMS Document Description */
  description?: Maybe<Scalars['String']>;
  /**
   * @deprecated |||
   * |-|-:|
   * | Reason | This field does not support values larger than 2 gigabytes. Please use "fileSizeStr". |
   * | Removal Date | 2024-04-03 |
   * | Deprecation Date | 2021-08-19 |
   */
  fileSize?: Maybe<Scalars['Int']>;
  /** The size of this Document in bytes. Returned as string, to allow universal support for values larger than 2 gigabytes. */
  fileSizeStr?: Maybe<Scalars['String']>;
  /** DMS Document ID */
  id?: Maybe<Scalars['ID']>;
  /** An identifier used to fetch the Document Revision from the DMS. */
  identifyingHash?: Maybe<Scalars['String']>;
  /** DMS Document Name */
  name?: Maybe<Scalars['String']>;
};

/** Content in the form of a Document */
export type Document = Content & Node & {
  __typename?: 'Document';
  /** Flag indicating if the content should be auto completed on Learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the Content */
  displayName?: Maybe<Scalars['String']>;
  /**
   * @deprecated |||
   * |-|-:|
   * | Reason | This field does not support values larger than 2 gigabytes. Please use "fileSizeStr". |
   * | Removal Date | 2024-04-03 |
   * | Deprecation Date | 2021-08-19 |
   */
  fileSize?: Maybe<Scalars['Int']>;
  /**
   * The size of this Document Revision in bytes. Returned as string, to allow
   * universal support for values larger than 2 gigabytes.
   */
  fileSizeStr?: Maybe<Scalars['String']>;
  /** Description of Content. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the Document */
  id?: Maybe<Scalars['ID']>;
  /** An identifier used to fetch the Document Revision */
  identifyingHash?: Maybe<Scalars['String']>;
  /** List of Training Pass Type IDs that grant access to this content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** The original extension of the file, without the dot */
  originalExtension?: Maybe<Scalars['String']>;
  /** Type of the Content */
  type?: Maybe<Scalars['String']>;
};

/** A Document Objective on a Learning Path */
export type DocumentObjective = LearningObjective & Node & {
  __typename?: 'DocumentObjective';
  /** The number of credits this Learning Objective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The document that must be accessed to complete this objective */
  document?: Maybe<Document>;
  /** The expected required time in days to complete the learning objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** ID of the Document Objective */
  id?: Maybe<Scalars['ID']>;
  /** The order of this Learning Objective in the set of Learning Path Objectives */
  order?: Maybe<Scalars['Int']>;
};

/** The Outcome from the Document Objective */
export type DocumentOutcome = LearningPathResult & Node & {
  __typename?: 'DocumentOutcome';
  /** Denotes whether or not the Outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The number of credits that the Outcome represents */
  credits?: Maybe<Scalars['Int']>;
  /** The Document to which this Outcome refers to */
  document?: Maybe<Document>;
  /** ID for the Document Outcome */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the Learning Objective to which the Outcome refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
};

/** An input for creating an external Kryterion resource */
export type EnsureKryterionAccountInput = {
  /** The ID of the Kryterion Activity */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Registration for which to create a Kryterion Account */
  registrationId?: Maybe<Scalars['ID']>;
};

/** The Response for a Kryterion resource creation */
export type EnsureKryterionAccountResponseType = {
  __typename?: 'EnsureKryterionAccountResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** Boolean indicating whether a Kryterion Account exists for the Registration */
  kryterionAccountExists?: Maybe<Scalars['Boolean']>;
  /** The Learner for which we have created a Kryterion Account */
  registration?: Maybe<Registration>;
};

/** The instance of training covering a particular course at a set time and location */
export type Event = {
  __typename?: 'Event';
  /** The number of days this Event is accessible for */
  accessDuration?: Maybe<Scalars['Int']>;
  /** The ending date and time of the latest, acitve classroom Session for the Event */
  classroomEnd?: Maybe<Scalars['String']>;
  /** The starting date and time of the earliest, active classroom Session for the Event */
  classroomStart?: Maybe<Scalars['String']>;
  /** Code for the Event */
  code?: Maybe<Scalars['String']>;
  /** The form the training takes */
  deliveryMethod?: Maybe<DeliveryMethod>;
  /** Documents mapped to this Event */
  documents: Array<DmsDocument>;
  /** The date and time the Event ends */
  end?: Maybe<Scalars['String']>;
  /** ID of the Event */
  id?: Maybe<Scalars['ID']>;
  /** Hash for the Event Image */
  imageHash?: Maybe<Scalars['String']>;
  /** The Instructors for the Event */
  instructors: Array<Instructor>;
  /** The state of the Event in its lifecycle */
  lifecycleState?: Maybe<Scalars['String']>;
  /** The Event LMS Announcements/Note */
  lmsAnnouncements?: Maybe<Scalars['String']>;
  /** The ending date and time when the LMS access or self paced learning is scheduled to close */
  lmsEnd?: Maybe<Scalars['String']>;
  /** The starting date and time when the LMS access or self paced learning is scheduled to open */
  lmsStart?: Maybe<Scalars['String']>;
  /** Location at which the Event takes place */
  location?: Maybe<Location>;
  /** Name of the Event */
  name?: Maybe<Scalars['String']>;
  /** Number of places remaining on the Event */
  remainingPlaces?: Maybe<Scalars['Int']>;
  /** The date and time the Event starts */
  start?: Maybe<Scalars['String']>;
  /** The time zone in which the dates and times of the Event are scheduled */
  timeZoneName?: Maybe<Scalars['String']>;
};

/** A paginated Event list related to the Node */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Event involved in the relationship */
  node?: Maybe<Event>;
};

/** Fields for filtering and ordering an Event list */
export enum EventField {
  /** The Code of the Course Template used to create this Event */
  CourseCode = 'courseCode',
  /** The ID of the Event */
  Id = 'id',
  /** The state of the Event in its lifecycle */
  LifecycleState = 'lifecycleState',
  /** The cut off date and time for registering onto an event */
  RegisterBy = 'registerBy',
  /** The remaining places on the Event */
  RemainingPlaces = 'remainingPlaces',
  /** The date and time the Event starts */
  Start = 'start',
  /** The date and time the Event starts with timezone information */
  TimeZonedStart = 'timeZonedStart',
  /** The title of the Event */
  Title = 'title'
}

/** Used to filter an Event List */
export type EventFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<EventField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type EventFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<EventField>;
};

/** Content in the form of an External Activity */
export type ExternalActivity = Content & Node & {
  __typename?: 'ExternalActivity';
  /** Flag indicating if the External Activity should be auto completed on Learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the External Activity */
  displayName?: Maybe<Scalars['String']>;
  /** URL for the Learner to engage with the External Activity */
  externalActivityUrl?: Maybe<Scalars['String']>;
  /** Description of the External Activity. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the External Activity */
  id?: Maybe<Scalars['ID']>;
  /** List of Training Pass Type IDs that grant access to this content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the External Activity is required for the Learner to complete the Event. */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** Type of the Content */
  type?: Maybe<Scalars['String']>;
};

/** An enumeration of statuses of External Activities */
export enum ExternalActivityStatus {
  /** The External Activity was completed */
  Completed = 'completed',
  /** The External Activity was failed */
  Failed = 'failed',
  /** The External Activity was passed */
  Passed = 'passed'
}

/** Data on the attempt of an External Activity */
export type ExternalAttempt = Node & {
  __typename?: 'ExternalAttempt';
  /** Accompanying documentation that is stored along with the progress of this External Activity */
  accompanyingDocumentation?: Maybe<Scalars['String']>;
  /** ID of the Attempt */
  id?: Maybe<Scalars['ID']>;
};

/** A summary of results for a Learner on a piece of External Content */
export type ExternalContentResult = ContentResult & Node & {
  __typename?: 'ExternalContentResult';
  /** The Learner attempts on the Content */
  attempts?: Maybe<Scalars['Int']>;
  /** The number of complete attempts the Learner has had on this Content */
  completedAttempts?: Maybe<Scalars['Int']>;
  /** The Content this result relates to */
  content?: Maybe<Content>;
  /** The ID to the piece of Content this result relates to */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Content */
  id?: Maybe<Scalars['ID']>;
  /** The date and time when the Content was last accessed */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** Information on the last attempt the Learner made on the External Activity */
  latestAttempt?: Maybe<ExternalAttempt>;
  /** The percentage complete the Learner has achieved on the Content */
  progress?: Maybe<Scalars['Decimal']>;
  /** The score the learner has achieved on the Content */
  score?: Maybe<Scalars['Decimal']>;
  /** The score percent the Learner has achieved on the Content */
  scorePercent?: Maybe<Scalars['Decimal']>;
  /** The current status of the Content */
  status?: Maybe<ContentResultStatus>;
};

/** An external link for a Portal */
export type ExternalLink = {
  __typename?: 'ExternalLink';
  /** Display text of the External Link */
  displayText?: Maybe<Scalars['String']>;
  /** Href of the External Link */
  href?: Maybe<Scalars['String']>;
  /** The name of the icon to display for the External Link */
  iconName?: Maybe<Scalars['String']>;
  /** Display position of the External Link */
  position?: Maybe<Scalars['Int']>;
};

/** An External Objective on a Learning Path */
export type ExternalObjective = LearningObjective & Node & {
  __typename?: 'ExternalObjective';
  /** The number of credits that this Learning Objective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The expected required time in days to complete the Learning Objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** External Objective */
  external?: Maybe<Scalars['String']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** ID of the External Objective */
  id?: Maybe<Scalars['ID']>;
  /** External Objective name */
  name?: Maybe<Scalars['String']>;
  /** The order of this Learning Objective in the set of Learning Path Objectives */
  order?: Maybe<Scalars['Int']>;
};

/** The Outcome from the External Objective */
export type ExternalOutcome = LearningPathResult & Node & {
  __typename?: 'ExternalOutcome';
  /** Denotes whether or not the outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The number of credits that the Outcome represents */
  credits?: Maybe<Scalars['Int']>;
  /** The External Activity to which the Outcome refers to */
  external?: Maybe<Scalars['String']>;
  /** ID for the External Outcome */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the Objective to which the Outcome refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
};

/** An error returned specific to a field */
export type FieldError = {
  __typename?: 'FieldError';
  /** Attribute to which the error relates */
  label?: Maybe<Scalars['String']>;
  /** Value that triggered the error */
  message?: Maybe<Scalars['String']>;
  /** Error message and resolution hint */
  value?: Maybe<Scalars['String']>;
};

/**
 * Used to limit results returned eq - Equals ge - Greater than or Equal to gt -
 * Greater Than like - Like le - Less than or Equal to lt - Less Than ne - Not
 * Equal isnull - Is Null notnull - Is Not Null wordlike - Match a word/expression
 * while excluding punctuations and case sensitivity in - Match any of a list of
 * values contains - Matches a subset of values notin - Does not match any of a list of values
 */
export enum FilterOperation {
  /** Field must be equal to value. */
  Eq = 'eq',
  /** Field must be greater than or equal to value. */
  Ge = 'ge',
  /** Field must be greater than value. */
  Gt = 'gt',
  /** Field must be less than or equal to value. */
  Le = 'le',
  /** Field must be like value, % is any String. */
  Like = 'like',
  /** Field must be less than value. */
  Lt = 'lt',
  /** Field must not equal value. */
  Ne = 'ne'
}

/** An input for fulfilling an objective on a Learning Path */
export type FulfilObjectiveInput = {
  /** The Event that will fulfil this Objective */
  eventId?: Maybe<Scalars['ID']>;
  /** The Learning Path Registration whose Objective will be fulfilled */
  learningPathRegistrationId?: Maybe<Scalars['ID']>;
  /** The Learning Path Objective to be fulfilled */
  objectiveId?: Maybe<Scalars['ID']>;
};

/** An Identity Provider e.g. an OAuth2 or SAML service */
export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  /** The ID of this Identity Provider */
  id?: Maybe<Scalars['ID']>;
  /** The name of this Identity Provider */
  name?: Maybe<Scalars['String']>;
  /** The URL that signs out of this Identity Provider */
  signOutUrl?: Maybe<Scalars['String']>;
  /** The endpoint on the SSO service to use to initiate single sign-on using this Identity Provider */
  singleSignOnInitiateEndpoint?: Maybe<Scalars['String']>;
};

/** A paginated IdentityProvider list related to the Node */
export type IdentityProviderConnection = {
  __typename?: 'IdentityProviderConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<IdentityProviderEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** A representation of a relationship between an Identity Provider and another Node */
export type IdentityProviderEdge = {
  __typename?: 'IdentityProviderEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Identity Provider involved in the relationship */
  node?: Maybe<IdentityProvider>;
};

/** An Instructor for a Course. */
export type Instructor = Node & {
  __typename?: 'Instructor';
  /** The staff identifier of the Instructor. */
  id: Scalars['ID'];
  /** The naem of the Instructor. */
  name: Scalars['String'];
};

/** Content in the form of a Kryterion Activity */
export type KryterionActivity = Content & Node & {
  __typename?: 'KryterionActivity';
  /** Flag indicating if the Content should be auto completed on learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the content */
  displayName?: Maybe<Scalars['String']>;
  /** Description of the Content. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the Kryterion Activity */
  id?: Maybe<Scalars['ID']>;
  /** List of Training Pass Type IDs that grant access to the Content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the Content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** Course ID for the Kryterion Activity */
  kryterionCourseId?: Maybe<Scalars['String']>;
  /** URL for the Kryterion Activity */
  kryterionUrl?: Maybe<Scalars['String']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** Type of Content */
  type?: Maybe<Scalars['String']>;
};

/** The learning mode of an Event */
export enum LearningMode {
  /** Blended */
  Blended = 'blended',
  /** Classroom */
  Classroom = 'classroom',
  /** Self-paced */
  SelfPaced = 'selfPaced'
}

/** An objective on a Learning Path */
export type LearningObjective = {
  /** The number of credits that this LearningObjective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The expected required time in days to complete the learning objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** The ID of the LearningObjective */
  id?: Maybe<Scalars['ID']>;
  /** The order of this LearningObjective in the set of LearningPath objectives */
  order?: Maybe<Scalars['Int']>;
};

/** The option group a LearningObjective belongs to, where the Learner only needs to complete a number of the grouped objectives */
export type LearningObjectiveGroup = {
  __typename?: 'LearningObjectiveGroup';
  /** The ID of the group (the LearningPathStep) */
  id: Scalars['ID'];
  /** The number of objectives in the group the Learner needs to complete */
  numRequired: Scalars['Int'];
};

/** A paginated LearningObjective list related to the Node */
export type LearningObjectiveConnection = {
  __typename?: 'LearningObjectiveConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<LearningObjectiveEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type LearningObjectiveEdge = {
  __typename?: 'LearningObjectiveEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Learning Objective involved in the relationship */
  node?: Maybe<LearningObjective>;
};

/** Fields for filtering and ordering a LearningObjective list */
export enum LearningObjectiveField {
  /** The ID of the LearningObjective */
  Id = 'id'
}

/** Used to filter a LearningObjective List */
export type LearningObjectiveFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<LearningObjectiveField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type LearningObjectiveFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<LearningObjectiveField>;
};

/** A Learning Journey containing a set of objectives to be completed */
export type LearningPath = Node & {
  __typename?: 'LearningPath';
  /** The AchievementType that can be earned when the Learning Path is passed */
  achievementType?: Maybe<AchievementType>;
  /** The latest End of the Learning Path based on its Learning Objectives */
  end?: Maybe<Scalars['Datetime']>;
  /** Whether the Learner needs to complete objectives in order */
  enforceObjectiveOrder: Scalars['Boolean'];
  /** The ID of the Learning Path */
  id: Scalars['ID'];
  /** URL to the image for the Learning Path */
  imageUrl?: Maybe<Scalars['String']>;
  /** The description of the Learning Path */
  longDescription?: Maybe<Scalars['String']>;
  /** The name of the Learning Path */
  name: Scalars['String'];
  /** The LearningObjectives of the LearningPath */
  objectives?: Maybe<LearningObjectiveConnection>;
  /** The earliest Start of the Learning Path based on its Learning Objectives */
  start?: Maybe<Scalars['Datetime']>;
};


/** A Learning Journey containing a set of objectives to be completed */
export type LearningPathObjectivesArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<LearningObjectiveFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<LearningObjectiveFieldOrder>;
};

/** The lifecycle state of a Learning Path Learner */
export enum LearningPathLearnerLifecycleState {
  /** Active Learning Path Learner */
  Active = 'active',
  /** Cancelled Learning Path Learner */
  Cancelled = 'cancelled',
  /** Completed Learning Path Learner */
  Completed = 'completed'
}

/** A Learning Path Objective on a Learning Path */
export type LearningPathObjective = LearningObjective & Node & {
  __typename?: 'LearningPathObjective';
  /** The number of credits that this Learning Objective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The expected required time in days to complete the Learning Objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** ID of the Learning Path Objective */
  id?: Maybe<Scalars['ID']>;
  /** The Learning Path used by this Objective */
  learningPath?: Maybe<LearningPath>;
  /** The order of this Learning Objective in the set of Learning Path Objectives */
  order?: Maybe<Scalars['Int']>;
};

/** The Outcome from the Learning Path Objective */
export type LearningPathOutcome = LearningPathResult & Node & {
  __typename?: 'LearningPathOutcome';
  /** Denotes whether or not the Outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The number of credits that the Outcome represents */
  credits?: Maybe<Scalars['Int']>;
  /** ID for the Learning Path Outcome */
  id?: Maybe<Scalars['ID']>;
  /** The Learning Path to which the Outcome refers to */
  learningPath?: Maybe<LearningPath>;
  /** The ID of the Objective to which the Outcome refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
};

/** A Learner registered on a Learning Path */
export type LearningPathRegistration = Node & Registerable & {
  __typename?: 'LearningPathRegistration';
  /** The Achievement earned by the Learner */
  achievement?: Maybe<Achievement>;
  /** The Brand ID for this Registerable */
  brandId?: Maybe<Scalars['String']>;
  /** ID of the Contact this Registration is for */
  contactId?: Maybe<Scalars['ID']>;
  /**
   * The expected progress is a percentage that a Learner is expected to complete
   * based on the current date and the path start date
   */
  expectedProgress?: Maybe<Scalars['Decimal']>;
  /** ID of the Learning Path Registration */
  id: Scalars['ID'];
  /** The active status of the Learning Path Learner */
  isActive: Scalars['Boolean'];
  /** The date and time a Learning Path Learner last viewed the Learning Path through the LMS */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The Learning Path the Registration is for */
  learningPath?: Maybe<LearningPath>;
  /** The Lifecycle State of the Learning Path Learner */
  lifecycleState: LearningPathLearnerLifecycleState;
  /** If the registration was made via a Training Pass, confirms access is still available */
  passAccessExpired: Scalars['Boolean'];
  /** The amount a Learner has completed on the Learning Path across all Learning Path Outcomes */
  progressMade?: Maybe<Scalars['Decimal']>;
  /** The Region ID for this Learning Path Registration */
  regionId?: Maybe<Scalars['ID']>;
  /** The Learning Path Result */
  results?: Maybe<LearningPathResultConnection>;
  /** The start date of the Learning Path Registration */
  startDate?: Maybe<Scalars['Datetime']>;
  /** Title for the Learning Path Registration */
  title?: Maybe<Scalars['String']>;
  /** An External Identifier to identify this Registerable instead of Contact */
  trackingIdentifier?: Maybe<Scalars['String']>;
  /** The ID of the Training Pass type used to register on the Learning Path */
  trainingPassTypeId?: Maybe<Scalars['ID']>;
};


/** A Learner registered on a Learning Path */
export type LearningPathRegistrationResultsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<LearningPathResultFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<LearningPathResultFieldOrder>;
};

/** A paginated LearningPathRegistration list related to the Node */
export type LearningPathRegistrationConnection = {
  __typename?: 'LearningPathRegistrationConnection';
  /** The paginated list of relationships */
  edges: Array<LearningPathRegistrationEdge>;
  /** Information regarding the pagination of the list */
  pageInfo: PageInfo;
};

/** an Edge type describes the connection between the node and its parent */
export type LearningPathRegistrationEdge = {
  __typename?: 'LearningPathRegistrationEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor: Scalars['String'];
  /** The Learning Path Registration involved in the relationship */
  node: LearningPathRegistration;
};

/** Fields for filtering and ordering a LearningPathRegistration list */
export enum LearningPathRegistrationField {
  /** The Brand ID for this Learning Path Registration */
  BrandId = 'brandId',
  /** ID of the Contact this Registration is for */
  ContactId = 'contactId',
  /** If the Learning Path has a parent */
  HasParent = 'hasParent',
  /** The ID of the Learning Path, Registration */
  Id = 'id',
  /** The active status of the Learning Path Learner */
  IsActive = 'isActive',
  /** Denotes whether or not the Learning Path has been completed */
  IsComplete = 'isComplete',
  /** The date and time a Learning Path Learner last viewed the Learning Path through the LMS */
  LastAccessed = 'lastAccessed',
  /** ID of the Contact this Registration is for */
  ManagedContactId = 'managedContactId',
  /** Title for the Learning Path Registration */
  Title = 'title'
}

/** Used to filter a LearningPathRegistration List */
export type LearningPathRegistrationFieldFilter = {
  /** Name of the field to filter the list */
  field: LearningPathRegistrationField;
  /** The method to compare the value to filter the list */
  operation: FilterOperation;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type LearningPathRegistrationFieldOrder = {
  /** Direction to order by */
  direction: OrderDirection;
  /** Name of the field to order by */
  field: LearningPathRegistrationField;
};

/** The Result from the Learning Path */
export type LearningPathResult = {
  /** Denotes whether or not the Outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The number of credits that the Learning Path Result represents */
  credits?: Maybe<Scalars['Int']>;
  /** ID for the Learning Path Result */
  id?: Maybe<Scalars['ID']>;
  /** ID of the Learning Objective to which the Learning Path Result refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Learning Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
};

/** A paginated LearningPathResult list related to the Node */
export type LearningPathResultConnection = {
  __typename?: 'LearningPathResultConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<LearningPathResultEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type LearningPathResultEdge = {
  __typename?: 'LearningPathResultEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Learning Path Result involved in the relationship */
  node?: Maybe<LearningPathResult>;
};

/** Fields for filtering and ordering a LearningPathResult list */
export enum LearningPathResultField {
  /** Denotes whether or not the Outcome has been completed */
  Completed = 'completed'
}

/** Used to filter a LearningPathResult List */
export type LearningPathResultFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<LearningPathResultField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type LearningPathResultFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<LearningPathResultField>;
};

/** A particular place used for training */
export type Location = Node & {
  __typename?: 'Location';
  /** ID of the Location */
  id: Scalars['ID'];
  /** Name of the Location */
  name: Scalars['String'];
};

/** A POS Custom Field that is mapped to a specific Entity's Field. */
export type MappedField = {
  __typename?: 'MappedField';
  /** The mapped entity type */
  entityType: MappedFieldEntityType;
  /** The mapped field */
  field: Scalars['String'];
};

/** An enumeration of different entity types that can be mapped */
export enum MappedFieldEntityType {
  /** Maps to a field on the Contact entity */
  Contact = 'contact',
  /** Maps to a custom field on the Contact entity */
  CustomContact = 'customContact',
  /** Maps to a custom field on the Learner entity */
  Learner = 'learner',
  /** Maps to a custom field on the Learning Path Learner entity */
  PathLearner = 'pathLearner'
}

/** Root Mutation Type */
export type Mutation = {
  __typename?: 'Mutation';
  /** Available Mutations on an Attempt */
  attempt?: Maybe<AttemptMutations>;
  /** Mutations available for a Cancellation Request */
  cancellationRequest?: Maybe<CancellationRequestMutations>;
  /** Mutations for Contacts */
  contact?: Maybe<ContactMutations>;
  /** Available Mutations on a Registerable */
  registerable?: Maybe<RegisterableMutations>;
  /** Available Mutations on a Registration */
  registration?: Maybe<RegistrationMutations>;
  /** Available Mutations for Training Requests */
  trainingRequest?: Maybe<TrainingRequestMutations>;
  /** Available Mutations on a Viewer */
  viewer?: Maybe<ViewerMutations>;
  /** Available Mutations on Viewer Credentials */
  viewerCredentials?: Maybe<ViewerCredentialsMutations>;
};

/** An entity with an ID */
export type Node = {
  /** The id of the node */
  id?: Maybe<Scalars['ID']>;
};

/** The step in the sales pipeline an Opportunity is currently in */
export type OpportunityStep = {
  __typename?: 'OpportunityStep';
  /** ID of the OpportunityStep */
  id?: Maybe<Scalars['ID']>;
  /** Name of the OpportunityStep */
  name?: Maybe<Scalars['String']>;
};

/** The directions used for sorts asc - Ascending desc - Descending */
export enum OrderDirection {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor to continue paginating backwards. */
  endCursor: Scalars['String'];
  /** If there are more items when paginating forwards. */
  hasNextPage: Scalars['Boolean'];
  /** If there are more items when paginating backwards. */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor to continue paginating forwards. */
  startCursor: Scalars['String'];
  /** The total number of records available for pagination. */
  totalRecords: Scalars['Int'];
};

/** A method of payment */
export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  /** Unique identifier for this Payment Method */
  id?: Maybe<Scalars['ID']>;
  /** A descriptive name for this Payment Method */
  name?: Maybe<Scalars['String']>;
};

/** An Input for a Personal Name of an entity */
export type PersonalNameInputType = {
  /** The first name of the person */
  firstName?: Maybe<Scalars['String']>;
  /** The last name of the person */
  lastName?: Maybe<Scalars['String']>;
};

/** Fields for filtering and ordering a PointOfSale list */
export enum PointOfSaleField {
  /** Denotes if the PointOfSaleField can be used with a Course Template */
  IsValidForCourseTemplate = 'isValidForCourseTemplate'
}

/** Point of Sale Field Entity Type */
export enum PointOfSaleFieldEntityType {
  /** The Point of Sale field is for an Event */
  EventRegistration = 'EventRegistration',
  /** The Point of Sale field is for a Learning Path */
  PathRegistration = 'PathRegistration'
}

/** Used to filter a PointOfSale List */
export type PointOfSaleFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<PointOfSaleField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Point of Sale Value */
export type PointOfSaleFieldValueType = {
  /** The Key for the Point of Sale Field */
  definitionKey: Scalars['String'];
  /** The Value of the Point of Sale field */
  value?: Maybe<Scalars['String']>;
};

/** A Point of Sale Field */
export type PointOfSaleLearnerFieldDefinition = {
  __typename?: 'PointOfSaleLearnerFieldDefinition';
  /** A description explaining the use of the Custom Field */
  description?: Maybe<Scalars['String']>;
  /** Whether the custom field is required */
  isRequired: Scalars['Boolean'];
  /** The identifier for this definition */
  key: Scalars['String'];
  /** The label of the Custom Field Definiton */
  label: Scalars['String'];
  /** The mapping between an entity type and a field */
  mappedField?: Maybe<MappedField>;
  /** Choices to present for a Custom Field with choice options */
  options?: Maybe<Array<PointOfSaleLearnerFieldDefinitionOption>>;
  /** The Learner Details Information section that this definition should be displayed in */
  section?: Maybe<Scalars['String']>;
  /** The type of value allowed for this Custom Field */
  type: Scalars['String'];
};

/** A choice to present for a Custom Field with choice options */
export type PointOfSaleLearnerFieldDefinitionOption = {
  __typename?: 'PointOfSaleLearnerFieldDefinitionOption';
  /** The label of the option */
  label: Scalars['String'];
  /** The value of the option */
  value: Scalars['String'];
};

/** A separate website that Contacts can access, for example: An LMS or Web Store */
export type Portal = {
  __typename?: 'Portal';
  /** The Brand that owns this Portal */
  brand?: Maybe<Brand>;
  /** The URL that the Contact is redirected to if they log in with no content to view */
  emptyPortalRedirectUrl?: Maybe<Scalars['String']>;
  /** The External Links associated with this Portal */
  externalLinks?: Maybe<Array<Maybe<ExternalLink>>>;
  /** The Identity Providers for this Portal */
  identityProviders?: Maybe<IdentityProviderConnection>;
  /** Dictates if Approval Portal behaviours are enabled for this Portal */
  isApprovalPortal?: Maybe<Scalars['Boolean']>;
  /** Dictates if Booking Portal behaviours are enabled for this Portal */
  isBookingPortal?: Maybe<Scalars['Boolean']>;
  /** Dictates if Self-Registration behaviours are enabled for this Portal */
  isSelfRegistrationPortal: Scalars['Boolean'];
  /** The WebLink Portals associated with this Portal */
  linkedWebLinkPortals?: Maybe<Array<Maybe<WebLinkPortal>>>;
  /** Indicates profile behaviors enabled for this Portal */
  profileSettings: ProfileSettings;
  /** Indicates if Contacts can log into this Portal only by Single Sign On */
  singleSignOnOnly?: Maybe<Scalars['Boolean']>;
  /** The terms and conditions for Portal checkout flow */
  termsAndConditions?: Maybe<Scalars['String']>;
};

/** CustomFieldDefinition for a Type on a Portal */
export type PortalCustomFieldTemplate = {
  __typename?: 'PortalCustomFieldTemplate';
  /** A description explaining the use for the Custom Field */
  description?: Maybe<Scalars['String']>;
  /** The identifier for this definition */
  key?: Maybe<Scalars['String']>;
  /** The name for this definition */
  name?: Maybe<Scalars['String']>;
  /** Choices to present for a Custom Field with choice options */
  options?: Maybe<Array<Maybe<PortalCustomFieldTemplateOption>>>;
  /** The type of value allowed for this Custom Field */
  type?: Maybe<Scalars['String']>;
};

/** An option for a PortalCustomFieldTemplate */
export type PortalCustomFieldTemplateOption = {
  __typename?: 'PortalCustomFieldTemplateOption';
  /** The label for the option */
  label?: Maybe<Scalars['String']>;
  /** The value of the option */
  value?: Maybe<Scalars['String']>;
};

/** A postal address */
export type PostalAddress = {
  __typename?: 'PostalAddress';
  /** The Country the address is within */
  country?: Maybe<Country>;
  /** The postal code or zip code */
  postcode?: Maybe<Scalars['String']>;
  /** The State/Province of the Address */
  province?: Maybe<Province>;
  /** The region, country, or state */
  region?: Maybe<Scalars['String']>;
  /** The first line of the address, typically unit, street number, or intended recipient */
  streetAddress1?: Maybe<Scalars['String']>;
  /** The second line of the address, typically street, building, or residence address */
  streetAddress2?: Maybe<Scalars['String']>;
  /** The third line of the address, typically locality, or further miscellaneous address information */
  streetAddress3?: Maybe<Scalars['String']>;
  /** The city or town */
  town?: Maybe<Scalars['String']>;
};

/** An input for creating a postal address */
export type PostalAddressInput = {
  /** The ID of a Country for the Address */
  countryId?: Maybe<Scalars['String']>;
  /** The postal code or zip code */
  postcode?: Maybe<Scalars['String']>;
  /** The code of the State/Province of the Postal Address */
  provinceCode?: Maybe<Scalars['String']>;
  /** The region, country, or state */
  region?: Maybe<Scalars['String']>;
  /** The first line of the address, typically unit, street number, or intended recipient */
  streetAddress1?: Maybe<Scalars['String']>;
  /** The second line of the address, typically street, building, or residence address */
  streetAddress2?: Maybe<Scalars['String']>;
  /** The third line of the address, typically locality, or further miscellaneous address information */
  streetAddress3?: Maybe<Scalars['String']>;
  /** The city or town */
  town?: Maybe<Scalars['String']>;
};

/** Indicates profile behaviors enabled for this Portal */
export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  /** Is the Learner is allowed to edit the Profile email */
  allowEditEmail: Scalars['Boolean'];
  /** Is the Learner allowed to edit the Profile Job Title */
  allowEditJobTitle: Scalars['Boolean'];
  /** Is the Learner allowed to edit the Profile Name */
  allowEditName: Scalars['Boolean'];
  /** Is the Learner allowed to view the Profile Job Title */
  showJobTitle: Scalars['Boolean'];
};

/** An administrative subdivision of a nation with a designated ISO code */
export type Province = {
  __typename?: 'Province';
  /** ISO designated province code */
  code?: Maybe<Scalars['String']>;
  /** Country Code of the where the province is */
  countryCode?: Maybe<Scalars['String']>;
  /** Name of the Province */
  name?: Maybe<Scalars['String']>;
};

/** Root Query Type */
export type Query = {
  __typename?: 'Query';
  /** Fetches a list of Achievements */
  achievements: AchievementConnection;
  /** Achievements Count */
  achievementsCount?: Maybe<AchievementsCount>;
  /** Fetches a list of Cancellation Reasons */
  cancellationReasons?: Maybe<CancellationReasonConnection>;
  /** Fetches a list of Cancellation Requests */
  cancellationRequests?: Maybe<CancellationRequestConnection>;
  /** Query a Catalogue of Items to Sell */
  catalogue?: Maybe<CatalogueConnection>;
  /** Fetches Categories */
  categories?: Maybe<CategoryConnection>;
  /** Content and Registration */
  contentAndRegistrationDetails?: Maybe<ContentAndRegistration>;
  /** Fetches the Accounts that the Coordinator is responsible for */
  coordinatorManagedAccounts: AccountConnection;
  /** Fetches the Contacts belonging to the Accounts that the Coordinator is responsible for */
  coordinatorManagedContacts: ContactConnection;
  /** Course Preview */
  coursePreview?: Maybe<CoursePreviewConnection>;
  /** Fetches Events */
  events?: Maybe<EventConnection>;
  /** Returns Hello String */
  hello?: Maybe<Scalars['String']>;
  /** Fetches a list of Point of Sale Learner Fields */
  pointOfSaleLearnerFields?: Maybe<Array<PointOfSaleLearnerFieldDefinition>>;
  /** Fetches Portal Custom Field Templates */
  portalCustomFieldTemplates?: Maybe<Array<Maybe<PortalCustomFieldTemplate>>>;
  /** Fetches a Portal for a specified Host URL */
  portalForHost?: Maybe<Portal>;
  /** Fetches Registerables */
  registerables?: Maybe<RegisterableConnection>;
  /** Registerables Count */
  registerablesCount?: Maybe<RegisterablesCount>;
  /** Fetches Registrations */
  registrations?: Maybe<RegistrationConnection>;
  /** Fetches Registrations with Progress */
  registrationsWithProgress?: Maybe<RegistrationWithProgressConnection>;
  /** Fetches a list of Training Token Transactions */
  tokenIssueTransactions?: Maybe<TokenIssueTransactions>;
  /** Fetches a list of Training Pass Types */
  trainingPassTypes?: Maybe<TrainingPassTypeConnection>;
  /** Fetches Training Requests */
  trainingRequests?: Maybe<TrainingRequestConnection>;
  /** Fetches a list of Training Token Issues */
  trainingTokenIssues?: Maybe<TrainingTokenIssueConnection>;
  /** Fetches information about the currently logged in user */
  viewer?: Maybe<Viewer>;
};


/** Root Query Type */
export type QueryAchievementsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<AchievementFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<AchievementFieldOrder>;
};


/** Root Query Type */
export type QueryAchievementsCountArgs = {
  filters?: Maybe<Array<Maybe<AchievementFieldFilter>>>;
};


/** Root Query Type */
export type QueryCancellationReasonsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CancellationReasonFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<CancellationReasonFieldOrder>;
};


/** Root Query Type */
export type QueryCancellationRequestsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CancellationRequestFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<CancellationRequestFieldOrder>;
};


/** Root Query Type */
export type QueryCatalogueArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CatalogueFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<CatalogueFieldOrder>;
};


/** Root Query Type */
export type QueryContentAndRegistrationDetailsArgs = {
  contentId?: Maybe<Scalars['ID']>;
};


/** Root Query Type */
export type QueryCoordinatorManagedAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<AccountFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<AccountFieldOrder>;
};


/** Root Query Type */
export type QueryCoordinatorManagedContactsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<ContactFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<ContactFieldOrder>;
};


/** Root Query Type */
export type QueryCoursePreviewArgs = {
  jwt?: Maybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryEventsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<EventFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<EventFieldOrder>;
};


/** Root Query Type */
export type QueryPointOfSaleLearnerFieldsArgs = {
  entityType?: Maybe<PointOfSaleFieldEntityType>;
  filters?: Maybe<Array<Maybe<PointOfSaleFieldFilter>>>;
};


/** Root Query Type */
export type QueryPortalCustomFieldTemplatesArgs = {
  type?: Maybe<SupportsCustomFieldPortalEntities>;
};


/** Root Query Type */
export type QueryPortalForHostArgs = {
  host?: Maybe<Scalars['URL']>;
};


/** Root Query Type */
export type QueryRegisterablesArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<RegisterableFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<RegisterableFieldOrder>;
};


/** Root Query Type */
export type QueryRegisterablesCountArgs = {
  filters?: Maybe<Array<Maybe<RegisterableFieldFilter>>>;
};


/** Root Query Type */
export type QueryRegistrationsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<RegistrationFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<RegistrationFieldOrder>;
};


/** Root Query Type */
export type QueryRegistrationsWithProgressArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<RegistrationFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<RegistrationFieldOrder>;
};


/** Root Query Type */
export type QueryTokenIssueTransactionsArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<TokenIssueTransactionFieldOrder>;
  tokenIssueId?: Maybe<Scalars['ID']>;
};


/** Root Query Type */
export type QueryTrainingRequestsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<TrainingRequestFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<TrainingRequestFieldOrder>;
};

/** An input for recording a submitted discussion comment */
export type RecordDiscussionCommentInput = {
  /** The actual comment submitted */
  comment: Scalars['String'];
  /** The ID of the Discussion Content */
  contentId: Scalars['ID'];
  /** The ID of the Registration submitting the discussion comment */
  registrationId: Scalars['ID'];
};

/** An input for recording external content being accessed */
export type RecordExternalContentAccessedInput = {
  /** The ID of the External Activity */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Registration with the External Activity */
  registrationId?: Maybe<Scalars['ID']>;
};

/** An input for recording External progress */
export type RecordExternalProgressInput = {
  /** Up to 64kb of data to store relevant to this External Activity */
  accompanyingDocumentation?: Maybe<Scalars['String']>;
  /** The ID of the Attempt for which to record progress */
  attemptId: Scalars['ID'];
  /** The status of the External Activity */
  status: ExternalActivityStatus;
};

/** An input for recording a resource download */
export type RecordResourceDownloadInput = {
  /** The ID of the Content being downloaded */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Registration downloading the resource */
  registrationId?: Maybe<Scalars['ID']>;
};

/** An input for recording SCORM progress */
export type RecordScormProgressInput = {
  /** The ID of the Attempt for which to record progress */
  attemptId?: Maybe<Scalars['ID']>;
  /** The ID of the Content being progressed */
  contentId?: Maybe<Scalars['ID']>;
  /** The data associated with the SCORM progress */
  data?: Maybe<Scalars['String']>;
  /** The ID of the Registration progressing the SCORM Content */
  registrationId?: Maybe<Scalars['ID']>;
  /** Flag indicating the end of SCORM session (LMSFinish/Terminate call) */
  sessionFinished?: Maybe<Scalars['Boolean']>;
};

/** An input for recording video progress */
export type RecordVideoProgressInput = {
  /** The ID of the Content being viewed */
  contentId?: Maybe<Scalars['ID']>;
  /** The data associated with the Video progress */
  data?: Maybe<Scalars['String']>;
  /** The ID of the Registration viewing the Video */
  registrationId?: Maybe<Scalars['ID']>;
};

/** Represents a Contact participating in learning through an Event or a Learning Path */
export type Registerable = {
  /** The Achievement earned by the Learner */
  achievement?: Maybe<Achievement>;
  /** The Brand ID for this Registerable */
  brandId?: Maybe<Scalars['String']>;
  /** The Learner or Learning Path Learners contact ID */
  contactId?: Maybe<Scalars['ID']>;
  /** The ID of the Registerable */
  id: Scalars['ID'];
  /** The Learner or Learning Path Learners Active Status */
  isActive: Scalars['Boolean'];
  /** The last datetime a Learner or Learning Path Learner accessed in the LMS */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The Title to show on the LMS for this Registerable */
  title?: Maybe<Scalars['String']>;
};

/** A paginated Registerable list related to the Node */
export type RegisterableConnection = {
  __typename?: 'RegisterableConnection';
  /** The paginated list of relationships */
  edges: Array<Maybe<RegisterableEdge>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type RegisterableEdge = {
  __typename?: 'RegisterableEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Registerable involved in the relationship */
  node?: Maybe<Registerable>;
};

/** Fields for filtering and ordering a Registerable list */
export enum RegisterableField {
  /** If true, it will return registerables for all brands, not just the portal brand (default: false) */
  AllBrands = 'allBrands',
  /** The Brand ID for this Registerable */
  BrandId = 'brandId',
  /** The Learner or Learning Path Learner's Contact ID */
  ContactId = 'contactId',
  /** If the registerable is a Learning Path, if that Learning Path has a parent */
  HasParent = 'hasParent',
  /** The ID of the Registerable */
  Id = 'id',
  /** The Learner or Learning Path Learners Active Status */
  IsActive = 'isActive',
  /** Denotes whether or not the Registerable has been completed */
  IsComplete = 'isComplete',
  /** The last datetime a Learner or Learning Path Learner accessed in the LMS */
  LastAccessed = 'lastAccessed',
  /** The Learner or Learning Path Learner's Contact ID */
  ManagedContactId = 'managedContactId',
  /** If the Registerable was made with a Training Pass, confirms access is still available */
  PassAccessExpired = 'passAccessExpired',
  /** The title of the Registerable */
  Title = 'title'
}

/** Used to filter a Registerable List */
export type RegisterableFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<RegisterableField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type RegisterableFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<RegisterableField>;
};

/** A Response from mutating a Registerable */
export type RegisterableMutateResponseType = {
  __typename?: 'RegisterableMutateResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registerable that was mutated */
  registerable?: Maybe<Registerable>;
};

/** Mutations for Registerables */
export type RegisterableMutations = {
  __typename?: 'RegisterableMutations';
  /** Fulfil an abstract Learning Objective with a concrete objective */
  fulfilObjective?: Maybe<RegisterableMutateResponseType>;
};


/** Mutations for Registerables */
export type RegisterableMutationsFulfilObjectiveArgs = {
  input?: Maybe<FulfilObjectiveInput>;
};

/** Count of Registerables */
export type RegisterablesCount = {
  __typename?: 'RegisterablesCount';
  /** The number of Registerables */
  count?: Maybe<Scalars['Int']>;
};

/** An input for registering onto an Event */
export type RegisterEventParticipationInput = {
  /** The ID of the Event on which to register */
  eventId: Scalars['ID'];
};

/** A response from registering onto an Event */
export type RegisterEventParticipationResponseType = {
  __typename?: 'RegisterEventParticipationResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registration that was created for the Event */
  registration?: Maybe<Registration>;
};

/** An input for registering onto a Learning Path */
export type RegisterLearningPathLearnerInput = {
  /** The ID of the Learning Path on which to register */
  learningPathId: Scalars['ID'];
  /** Which Events have been selected to fulfill Course Objectives on the Learning Path */
  selectedEvents?: Maybe<Array<SelectedLearningObjectiveEvent>>;
  /** The ID of the held Training Pass to be used for registration */
  trainingPassTypeId?: Maybe<Scalars['String']>;
};

/** A response from registering onto a Learning Path */
export type RegisterLearningPathLearnerResponseType = {
  __typename?: 'RegisterLearningPathLearnerResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registration that was created for the Learning Path */
  registration?: Maybe<LearningPathRegistration>;
};

/** An input for registering onto an Event using a Training Pass */
export type RegisterPassholderInput = {
  /** The ID of the Event on which to register */
  eventId: Scalars['ID'];
  /** The ID of the held Training Pass to be used for registration */
  trainingPassId: Scalars['ID'];
};

/** A response from registering onto an Event using a Training Pass */
export type RegisterPassholderResponseType = {
  __typename?: 'RegisterPassholderResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registration that was created for the Event */
  registration?: Maybe<Registration>;
};

/** A Registration */
export type Registration = Node & Registerable & {
  __typename?: 'Registration';
  /** The Achievement */
  achievement?: Maybe<Achievement>;
  /** List of Achievements */
  achievements?: Maybe<Array<Maybe<Achievement>>>;
  /** Details of the learner attendance */
  attendance?: Maybe<Attendance>;
  /** The Brand ID for this Registration */
  brandId?: Maybe<Scalars['String']>;
  /** The number of pieces of Content that have been completed */
  completedPiecesOfContent: Scalars['Int'];
  /** ID of the Contact linked to the Registration */
  contactId?: Maybe<Scalars['ID']>;
  /** A paginated ContentResult list related to the Node */
  contentResults?: Maybe<ContentResultConnection>;
  /** Course linked to the Registration */
  course?: Maybe<Course>;
  /** ID of the Event linked to the Registration */
  eventId?: Maybe<Scalars['ID']>;
  /** The date and time from which the Learner can no longer access the Event */
  expiry?: Maybe<Scalars['Datetime']>;
  /** Whether the Learner has passed or failed */
  hasPassed?: Maybe<Scalars['Boolean']>;
  /** ID of the Registration */
  id: Scalars['ID'];
  /** Whether the Registration is Active */
  isActive: Scalars['Boolean'];
  /** The date and time the Learner last accessed this in the LMS */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The Learning Path Registration */
  learningPathRegistration?: Maybe<LearningPathRegistration>;
  /** If the Registration was made with a Training Pass, confirms access is still available */
  passAccessExpired?: Maybe<Scalars['Boolean']>;
  /** The quantity of Learners on this Registration */
  quantity: Scalars['Int'];
  /** The Title to show in the LMS for this Registration */
  title?: Maybe<Scalars['String']>;
  /** The total pieces of Content for this Registration */
  totalPiecesOfContent: Scalars['Int'];
  /** An External Identifier used to identify this Registration */
  trackingId?: Maybe<Scalars['String']>;
  /** The ID of the Training Pass Type that was used to Register */
  trainingPassTypeId?: Maybe<Scalars['ID']>;
  /** Type of Registration */
  type: Scalars['String'];
};


/** A Registration */
export type RegistrationContentResultsArgs = {
  after?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<ContentResultFieldFilter>>>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<ContentResultFieldOrder>;
};

/** A paginated Registration list related to the Node */
export type RegistrationConnection = {
  __typename?: 'RegistrationConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<RegistrationEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** Details of the Registration */
export type RegistrationDetails = {
  __typename?: 'RegistrationDetails';
  /** ID of the Learner */
  contactId?: Maybe<Scalars['ID']>;
  /** A summary of results for this Learner */
  contentResult?: Maybe<ContentResult>;
  /** Registration Details identifier */
  id?: Maybe<Scalars['ID']>;
  /** Denotes whether this is a record for Unnamed Learner(s) */
  isUnnamed?: Maybe<Scalars['Boolean']>;
  /** The Learning Path for the Event this Learner is Registered on */
  learningPath?: Maybe<LearningPath>;
  /** An external identifier to identify this Learner */
  trackingId?: Maybe<Scalars['String']>;
};

/** an Edge type describes the connection between the node and its parent */
export type RegistrationEdge = {
  __typename?: 'RegistrationEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Registration involved in the relationship */
  node?: Maybe<Registration>;
};

/** Fields for filtering and ordering a Registration list */
export enum RegistrationField {
  /** Whether the Registration is Active */
  Active = 'active',
  /** The end datetime of the Course of the Registration, with timezone information */
  CourseEnd = 'courseEnd',
  /** The end datetime of the Course of the Registration */
  CourseEndDate = 'courseEndDate',
  /** The ID of the Course linked to the Registration */
  CourseId = 'courseId',
  /** The last datetime a Learner or LearningPathLearner accessed the LMS */
  CourseLastAccessed = 'courseLastAccessed',
  /** The name of the Location of the Course of the Registration */
  CourseLocationName = 'courseLocationName',
  /** The start datetime of the Course of the Registration, with timezone information */
  CourseStart = 'courseStart',
  /** The start datetime of the Course of the Registration */
  CourseStartDate = 'courseStartDate',
  /** The ID of the Course Tempalte linked to the Registration */
  CourseTemplateId = 'courseTemplateId',
  /** The Title of the Course Tempplate of the Registration */
  CourseTitle = 'courseTitle',
  /** Denotes if this Registration is part of a Learning Path Registration */
  HasParentLearningPathRegistration = 'hasParentLearningPathRegistration',
  /** The ID of the Registration */
  Id = 'id',
  /** Denotes whether or not the Registration has been completed */
  IsComplete = 'isComplete',
  /** The date and time the Learner last accessed this event in the LMS */
  LastAccessed = 'lastAccessed'
}

/** Used to filter a Registration List */
export type RegistrationFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<RegistrationField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type RegistrationFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<RegistrationField>;
};

/** A Response from mutating a Registration */
export type RegistrationMutateResponseType = {
  __typename?: 'RegistrationMutateResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Registration that was mutated */
  registration?: Maybe<Registration>;
};

/** Mutations for Registrations */
export type RegistrationMutations = {
  __typename?: 'RegistrationMutations';
  /** Associate an Unnamed Learner with existing Contacts */
  associateUnnamedEventLearnerWithContacts?: Maybe<AssociateUnnamedLearnerWithContactsResponseType>;
  /** Creates an attempt on a piece of SCORM Content */
  attemptScormContent?: Maybe<RegistrationMutateResponseType>;
  /** Delete a Discussion Comment */
  deleteDiscussionComment: RegistrationMutateResponseType;
  /** Creates an account in Kryterion if one does not already exist */
  ensureKryterionAccount: EnsureKryterionAccountResponseType;
  /** Records a submitted discussion comment */
  recordDiscussionComment?: Maybe<RegistrationMutateResponseType>;
  /** Records a Registration's progress through a piece of External Content */
  recordExternalContentAccessed?: Maybe<RegistrationMutateResponseType>;
  /** Records when a resource or document is downloaded */
  recordResourceDownload?: Maybe<RegistrationMutateResponseType>;
  /** Records a Registration's progress through a piece of SCORM Content */
  recordScormProgress?: Maybe<RegistrationMutateResponseType>;
  /** Records a Registration's progress through a piece of Video Content */
  recordVideoProgress?: Maybe<RegistrationMutateResponseType>;
  /** Register onto an Event */
  registerEventParticipation?: Maybe<RegisterEventParticipationResponseType>;
  /** Register onto a Learning Path */
  registerLearningPathLearner?: Maybe<RegisterLearningPathLearnerResponseType>;
  /** Register onto an Event using a Training Pass */
  registerPassholder?: Maybe<RegisterPassholderResponseType>;
};


/** Mutations for Registrations */
export type RegistrationMutationsAssociateUnnamedEventLearnerWithContactsArgs = {
  input: AssociateUnnamedLearnerWithContactsInput;
};


/** Mutations for Registrations */
export type RegistrationMutationsAttemptScormContentArgs = {
  input?: Maybe<AttemptScormContentInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsDeleteDiscussionCommentArgs = {
  input: DeleteDiscussionCommentInput;
};


/** Mutations for Registrations */
export type RegistrationMutationsEnsureKryterionAccountArgs = {
  input?: Maybe<EnsureKryterionAccountInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRecordDiscussionCommentArgs = {
  input?: Maybe<RecordDiscussionCommentInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRecordExternalContentAccessedArgs = {
  input?: Maybe<RecordExternalContentAccessedInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRecordResourceDownloadArgs = {
  input?: Maybe<RecordResourceDownloadInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRecordScormProgressArgs = {
  input?: Maybe<RecordScormProgressInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRecordVideoProgressArgs = {
  input?: Maybe<RecordVideoProgressInput>;
};


/** Mutations for Registrations */
export type RegistrationMutationsRegisterEventParticipationArgs = {
  input: RegisterEventParticipationInput;
};


/** Mutations for Registrations */
export type RegistrationMutationsRegisterLearningPathLearnerArgs = {
  input: RegisterLearningPathLearnerInput;
};


/** Mutations for Registrations */
export type RegistrationMutationsRegisterPassholderArgs = {
  input: RegisterPassholderInput;
};

/** A Registration */
export type RegistrationWithProgress = Node & Registerable & {
  __typename?: 'RegistrationWithProgress';
  /** The Achievement */
  achievement?: Maybe<Achievement>;
  /** List of Achievements */
  achievements?: Maybe<Array<Maybe<Achievement>>>;
  /** Details of the learner attendance */
  attendance?: Maybe<Attendance>;
  /** The Brand ID for this Registration */
  brandId?: Maybe<Scalars['String']>;
  /** The number of pieces of Content that have been completed */
  completedPiecesOfContent: Scalars['Int'];
  /** ID of the Contact linked to the Registration */
  contactId?: Maybe<Scalars['ID']>;
  /** A paginated ContentResult list related to the Node */
  contentResults?: Maybe<ContentResultConnection>;
  /** Course linked to the Registration */
  course?: Maybe<Course>;
  /** ID of the Event linked to the Registration */
  eventId?: Maybe<Scalars['ID']>;
  /** The date and time from which the Learner can no longer access the Event */
  expiry?: Maybe<Scalars['Datetime']>;
  /** Whether the Learner has passed or failed */
  hasPassed?: Maybe<Scalars['Boolean']>;
  /** ID of the Registration */
  id: Scalars['ID'];
  /** Whether the Registration is Active */
  isActive: Scalars['Boolean'];
  /** The date and time the Learner last accessed this in the LMS */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The Learning Path Registration */
  learningPathRegistration?: Maybe<LearningPathRegistration>;
  /** If the Registration was made with a Training Pass, confirms access is still available */
  passAccessExpired?: Maybe<Scalars['Boolean']>;
  /** The quantity of Learners on this Registration */
  quantity: Scalars['Int'];
  /** The Title to show in the LMS for this Registration */
  title?: Maybe<Scalars['String']>;
  /** The total pieces of Content for this Registration */
  totalPiecesOfContent: Scalars['Int'];
  /** An External Identifier used to identify this Registration */
  trackingId?: Maybe<Scalars['String']>;
  /** The ID of the Training Pass Type that was used to Register */
  trainingPassTypeId?: Maybe<Scalars['ID']>;
  /** Type of Registration */
  type: Scalars['String'];
};

/** A paginated RegistrationWithProgress list related to the Node */
export type RegistrationWithProgressConnection = {
  __typename?: 'RegistrationWithProgressConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<RegistrationWithProgressEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type RegistrationWithProgressEdge = {
  __typename?: 'RegistrationWithProgressEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Registration With Progress involved in the relationship */
  node?: Maybe<RegistrationWithProgress>;
};

/** A summary of results for a Learner on a piece of EventContent */
export type ResourceContentResult = ContentResult & Node & {
  __typename?: 'ResourceContentResult';
  /** The attempts on this Content */
  attempts?: Maybe<Scalars['Int']>;
  /** The number of complete attempts the Learner has had on this Content */
  completedAttempts?: Maybe<Scalars['Int']>;
  /** The Content this result relates to */
  content?: Maybe<Content>;
  /** The ID of the piece of Content this result relates to */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Content Result */
  id?: Maybe<Scalars['ID']>;
  /** The date and time when the Content was last accessed */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The percentage complete the Learner has achieved on the Content */
  progress?: Maybe<Scalars['Decimal']>;
  /** The score the Learner has achieved on the Content */
  score?: Maybe<Scalars['Decimal']>;
  /** The score percent the Learner has achieved on the Content */
  scorePercent?: Maybe<Scalars['Decimal']>;
  /** The current status of the Content */
  status?: Maybe<ContentResultStatus>;
};

/** Content in the form of SCORM */
export type Scorm = Content & Node & {
  __typename?: 'Scorm';
  /** Flag indicating if the Content should be auto completed on Learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name for the content */
  displayName?: Maybe<Scalars['String']>;
  /** The entrypoint for the SCORM content */
  entrypoint?: Maybe<Scalars['String']>;
  /**
   * @deprecated |||
   * |-|-:|
   * | Reason | This field does not support values larger than 2 gigabytes. Please use "fileSizeStr". |
   * | Removal Date | 2024-04-03 |
   * | Deprecation Date | 2021-08-19 |
   */
  fileSize?: Maybe<Scalars['Int']>;
  /** The size of the SCORM file in bytes. Returned as string, to allow universal support for values larger than 2 gigabytes. */
  fileSizeStr?: Maybe<Scalars['String']>;
  /** Description for the Content. Contains HTML */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the SCORM Content */
  id?: Maybe<Scalars['ID']>;
  /** An identifier used to fetch the Document Revision */
  identifyingHash?: Maybe<Scalars['String']>;
  /** List of Training Pass Type IDs that grant access to this Content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed for annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The maxiumum number of attempts permitted for this SCORM Content */
  maxAttempts?: Maybe<Scalars['Int']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** The type of Content */
  type?: Maybe<Scalars['String']>;
  /** The version of the SCORM Content */
  version?: Maybe<Version>;
};

/** Data on a SCORM Attempt */
export type ScormAttempt = Node & {
  __typename?: 'ScormAttempt';
  /** Information about the ScormAttempt */
  data?: Maybe<Scalars['String']>;
  /** ID of the Attempt */
  id?: Maybe<Scalars['ID']>;
};

/** A summary of results for a Learner on a piece of SCORM type EventContent */
export type ScormContentResult = ContentResult & Node & {
  __typename?: 'ScormContentResult';
  /** The Learner attempts on the Content */
  attempts?: Maybe<Scalars['Int']>;
  /** The number of Complete attempts the Learner has had on this Content */
  completedAttempts?: Maybe<Scalars['Int']>;
  /** The Content this result relates to */
  content?: Maybe<Content>;
  /** The ID to the piece of Content this Result relates to */
  contentId?: Maybe<Scalars['ID']>;
  /** ID of the Content Result */
  id?: Maybe<Scalars['ID']>;
  /** The date and time when the Content was last accessed */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** Information on the last attempt the Learner made on the SCORM content */
  latestAttempt?: Maybe<ScormAttempt>;
  /** The percentage complete the Learner has achieved on the Content */
  progress?: Maybe<Scalars['Decimal']>;
  /** The score the Learner has achieved on this Content */
  score?: Maybe<Scalars['Decimal']>;
  /** The score percent the learner has achieved on the Content */
  scorePercent?: Maybe<Scalars['Decimal']>;
  /** The current status of the Content */
  status?: Maybe<ContentResultStatus>;
};

/** An input for specifying which Events will fulfill a Course Objective when registering onto a Learning Path */
export type SelectedLearningObjectiveEvent = {
  /** The Event that has been selected to fulfill this Objective */
  eventId?: Maybe<Scalars['String']>;
  /** The Learning Path Objective to be fulfilled */
  objectiveId: Scalars['ID'];
};

/** Used to Separator Content on a Course */
export type Separator = Content & Node & {
  __typename?: 'Separator';
  /** Flag indicating if the Content should be autocompleted on Learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the Separator */
  displayName?: Maybe<Scalars['String']>;
  /** Optional description - contains HTML */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the Separator */
  id?: Maybe<Scalars['ID']>;
  /** List of Training Pass Type IDs that grant access to this content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the Content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Separator should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** The type of Content */
  type?: Maybe<Scalars['String']>;
};

/** A period of time used for learning or teaching */
export type Session = {
  __typename?: 'Session';
  /** ID of the Session */
  id?: Maybe<Scalars['ID']>;
  /** Location at which the Event takes place */
  location?: Maybe<Location>;
  /** The URL of the remote meeting */
  remoteMeetingUrl?: Maybe<Scalars['String']>;
  /** Time zone offset date and time the Session ends */
  timeZonedEnd?: Maybe<Scalars['Datetime']>;
  /** Time zone offset date and time the Session starts */
  timeZonedStart?: Maybe<Scalars['Datetime']>;
  /** Title of the Session */
  title?: Maybe<Scalars['String']>;
};

/** A summary of session details */
export type SessionDetail = {
  __typename?: 'SessionDetail';
  /** The attendance Status of the Learner */
  attendanceMark?: Maybe<Scalars['String']>;
  /** Sessions that belong to the Event */
  session?: Maybe<Session>;
};

/** A paginated SessionDetail list related to the Node */
export type SessionDetailConnection = {
  __typename?: 'SessionDetailConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<SessionDetailEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type SessionDetailEdge = {
  __typename?: 'SessionDetailEdge';
  /** The Session Detail involved in the relationship */
  node?: Maybe<SessionDetail>;
};

/** A paginated Sessions list related to the Node */
export type SessionsConnection = {
  __typename?: 'SessionsConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<SessionsEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type SessionsEdge = {
  __typename?: 'SessionsEdge';
  /** The Session involved in the relationship */
  node?: Maybe<Session>;
};

/** An input for setting a password */
export type SetPasswordInputType = {
  /** The current password */
  currentPassword?: Maybe<Scalars['String']>;
  /** The URL of the Host of the Portal for which to set the password */
  host?: Maybe<Scalars['String']>;
  /** The new password */
  newPassword?: Maybe<Scalars['String']>;
  /** Whether setting the password should be verified by email */
  verifyEmail?: Maybe<Scalars['Boolean']>;
};

/** Single Sign On Error */
export type SingleSignOnError = SingleSignOnResult & {
  __typename?: 'SingleSignOnError';
  /** Code */
  code?: Maybe<Scalars['String']>;
  /** Success Flag */
  success?: Maybe<Scalars['Boolean']>;
};

/** Single Sign On Result */
export type SingleSignOnResult = {
  /** Success Flag */
  success?: Maybe<Scalars['Boolean']>;
};

/** Single Sign On Success */
export type SingleSignOnSuccess = SingleSignOnResult & {
  __typename?: 'SingleSignOnSuccess';
  /** Portal Token */
  portalToken?: Maybe<Scalars['String']>;
  /** Previous Path */
  previousPath?: Maybe<Scalars['String']>;
  /** Success Flag */
  success?: Maybe<Scalars['Boolean']>;
  /** Username */
  username?: Maybe<Scalars['String']>;
};

/** A subcategory for a Category */
export type Subcategory = {
  __typename?: 'Subcategory';
  /** ID for the Subcategory */
  id?: Maybe<Scalars['ID']>;
  /** Name for the Subcategory */
  name?: Maybe<Scalars['String']>;
};

/** A paginated Subcategorylist related to the Node */
export type SubcategoryConnection = {
  __typename?: 'SubcategoryConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<SubcategoryEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type SubcategoryEdge = {
  __typename?: 'SubcategoryEdge';
  /** The Subcategory involved in the relationship */
  node?: Maybe<Subcategory>;
};

/** Types that support CustomField Definitions on a Portal */
export enum SupportsCustomFieldPortalEntities {
  /** The current Viewer */
  Viewer = 'Viewer'
}

/** A record of a balance change in a Token Account */
export type TokenIssueTransaction = {
  __typename?: 'TokenIssueTransaction';
  /** The amount by which the Account balance changed */
  balanceDelta?: Maybe<Scalars['Int']>;
  /** Notes describing the adjustment */
  notes?: Maybe<Scalars['String']>;
  /** When this Transaction occurred */
  occurredAt?: Maybe<Scalars['Datetime']>;
  /** The title of the Registerable that the Training Tokens were exchanged for */
  registerableTitle?: Maybe<Scalars['String']>;
  /** The number of the Token Receipt */
  tokenReceiptNumber?: Maybe<Scalars['String']>;
  /** Reason for the Training Token balance change */
  type?: Maybe<Scalars['String']>;
};

/** Fields for filtering and ordering a TokenIssueTransaction list */
export enum TokenIssueTransactionField {
  /** When this Transaction occurred */
  OccurredAt = 'occurredAt'
}

/** Used for ordering the results by a specific field and direction */
export type TokenIssueTransactionFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<TokenIssueTransactionField>;
};

/** Transactions agains a Token Issue */
export type TokenIssueTransactions = {
  __typename?: 'TokenIssueTransactions';
  /** The Training Token Transactions against the Token Issue */
  transactions?: Maybe<TrainingTokenIssueTransactionConnection>;
};

/** A Training Pass */
export type TrainingPass = {
  __typename?: 'TrainingPass';
  /** ID of the Training Pass */
  id?: Maybe<Scalars['ID']>;
  /**
   * Current status of this Training Pass. This is the only field you have to check
   * if you want to know if the Training Pass is active. This field is always up to date.
   */
  lifecycleState?: Maybe<Scalars['String']>;
  /** Code for the Training Pass Type linked to the Training Pass */
  trainingPassTypeCode?: Maybe<Scalars['String']>;
  /** The ID of the Training Pass Type linked to the Training Pass */
  trainingPassTypeId?: Maybe<Scalars['ID']>;
  /** Name of the Training Pass Type linked to the Training Pass */
  trainingPassTypeName?: Maybe<Scalars['String']>;
  /**
   * The UTC date and time this Training Pass should be valid from. To get current
   * Training Pass status, always use lifecycleState.
   */
  validFrom?: Maybe<Scalars['Datetime']>;
  /**
   * The UTC date and time this Training Pass should be valid until. To get current
   * Training Pass status, always use lifecycleState.
   */
  validUntil?: Maybe<Scalars['Datetime']>;
};

/** A Training Pass Type */
export type TrainingPassType = {
  __typename?: 'TrainingPassType';
  /** Code for the Training Pass Type */
  code?: Maybe<Scalars['String']>;
  /** Descriptiong of the Training Pass Type */
  description?: Maybe<Scalars['String']>;
  /** ID of the Training Pass Type */
  id?: Maybe<Scalars['ID']>;
  /** Name of the Training Pass Type */
  name?: Maybe<Scalars['String']>;
};

/** A paginated TrainingPassType list related to the Node */
export type TrainingPassTypeConnection = {
  __typename?: 'TrainingPassTypeConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<TrainingPassTypeEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type TrainingPassTypeEdge = {
  __typename?: 'TrainingPassTypeEdge';
  /** The Training Pass Type involved in the relationship */
  node?: Maybe<TrainingPassType>;
};

/** A Training Request Opportunity */
export type TrainingRequest = Node & {
  __typename?: 'TrainingRequest';
  /** Date and time the Training Request was created */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** ID of the Training Request */
  id?: Maybe<Scalars['ID']>;
  /** ID of the Registerable linked to the Training Request */
  registerableId?: Maybe<Scalars['ID']>;
  /** Name of the OpportunityStep */
  stageName?: Maybe<Scalars['String']>;
  /** State of the Training Request */
  state?: Maybe<Scalars['String']>;
  /** Name of the OpportunityStep */
  stepName?: Maybe<Scalars['String']>;
  /** The Training being requested */
  training?: Maybe<TrainingRequestItem>;
  /** Date and time the Training Request was updated */
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** A paginated TrainingRequest list related to the Node */
export type TrainingRequestConnection = {
  __typename?: 'TrainingRequestConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<TrainingRequestEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type TrainingRequestEdge = {
  __typename?: 'TrainingRequestEdge';
  /** An opaque string that indicates a specific point in paginating through a list */
  cursor?: Maybe<Scalars['String']>;
  /** The Training Request involved in the relationship */
  node?: Maybe<TrainingRequest>;
};

/** Fields for filtering and ordering a TrainingRequest list */
export enum TrainingRequestField {
  /** The ID of the Course Template being requested */
  CourseTemplateId = 'courseTemplateId',
  /** The date and time the Training Request was created */
  CreatedAt = 'createdAt',
  /** The ID of the TrainingRequestField */
  Id = 'id',
  /** The state of the Training Request */
  State = 'state',
  /** The name of the OpportunityStep the TrainingRequest is currently in */
  StepName = 'stepName',
  /** The date and time the Training Request was updated */
  UpdatedAt = 'updatedAt'
}

/** Used to filter a TrainingRequest List */
export type TrainingRequestFieldFilter = {
  /** Name of the field to filter the list */
  field?: Maybe<TrainingRequestField>;
  /** The method to compare the value to filter the list */
  operation?: Maybe<FilterOperation>;
  /** Value to filter the list */
  value?: Maybe<Scalars['String']>;
};

/** Used for ordering the results by a specific field and direction */
export type TrainingRequestFieldOrder = {
  /** Direction to order by */
  direction?: Maybe<OrderDirection>;
  /** Name of the field to order by */
  field?: Maybe<TrainingRequestField>;
};

/** An item of Training to be requested */
export type TrainingRequestItem = {
  __typename?: 'TrainingRequestItem';
  /** End date and time */
  end?: Maybe<Scalars['Datetime']>;
  /** The Training Request Item ID */
  id?: Maybe<Scalars['ID']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** Location */
  location?: Maybe<Scalars['String']>;
  /** Start date and time */
  start?: Maybe<Scalars['Datetime']>;
  /** Title of the Training being requested */
  title?: Maybe<Scalars['String']>;
  /** Type of the Training being requested */
  type?: Maybe<Scalars['String']>;
};

/** Mutations for Training Requests */
export type TrainingRequestMutations = {
  __typename?: 'TrainingRequestMutations';
  /** Create a new Training Request Opportunity */
  createTrainingRequest?: Maybe<TrainingRequestMutationsResponseType>;
};


/** Mutations for Training Requests */
export type TrainingRequestMutationsCreateTrainingRequestArgs = {
  input?: Maybe<CreateTrainingRequestInputType>;
};

/** The Response from mutating a Training Request */
export type TrainingRequestMutationsResponseType = {
  __typename?: 'TrainingRequestMutationsResponseType';
  /** Errors from the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The mutated Training Request */
  trainingRequest?: Maybe<TrainingRequest>;
};

/** A Block of Tokens Issued To An Account */
export type TrainingTokenIssue = {
  __typename?: 'TrainingTokenIssue';
  /** A timestamp representing when the Training Token was issued */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The number of unredeemed and unexpired tokens for this Token Issue */
  currentBalance?: Maybe<Scalars['Int']>;
  /** A timestamp representing when any remaining unused Tokens will be forfeited */
  expiresAt?: Maybe<Scalars['Datetime']>;
  /** ID of the Node */
  id?: Maybe<Scalars['ID']>;
  /** The number of tokens which were originally issued */
  initialBalance?: Maybe<Scalars['Int']>;
  /** Whether or not the expiresAt date has passed */
  isExpired?: Maybe<Scalars['Boolean']>;
  /**
   * Record Identifier used in previous versions of Administrate's API and should
   * only be used for Integrations requiring crossover between versions.
   */
  legacyCode?: Maybe<Scalars['String']>;
  /**
   * The Payment Code used for Paying using this Token Issue. Also contains the
   * value for any Imported Payment Code which was generated on a system out-with Administrate
   */
  paymentCode?: Maybe<Scalars['String']>;
  /** The number of tokens redeemed for this Token Issue */
  redeemed?: Maybe<Scalars['Int']>;
  /** The type of Training Token */
  tokenType?: Maybe<Scalars['String']>;
  /** Identifier for the type of Training Token */
  tokenTypeId?: Maybe<Scalars['ID']>;
};

/** A paginated Training Token Issue list related to the Node */
export type TrainingTokenIssueConnection = {
  __typename?: 'TrainingTokenIssueConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<TrainingTokenIssueEdge>>>;
};

/** an Edge type describes the connection between the node and its parent */
export type TrainingTokenIssueEdge = {
  __typename?: 'TrainingTokenIssueEdge';
  /** The Training Token Issue involved in the relationship */
  node?: Maybe<TrainingTokenIssue>;
};

/** A paginated Token Issue Transaction list related to the Node */
export type TrainingTokenIssueTransactionConnection = {
  __typename?: 'TrainingTokenIssueTransactionConnection';
  /** The paginated list of relationships */
  edges?: Maybe<Array<Maybe<TrainingTokenIssueTransactionEdge>>>;
  /** Information regarding the pagination of the list */
  pageInfo?: Maybe<PageInfo>;
};

/** an Edge type describes the connection between the node and its parent */
export type TrainingTokenIssueTransactionEdge = {
  __typename?: 'TrainingTokenIssueTransactionEdge';
  /** The Token Issue Transaction involved in the relationship */
  node?: Maybe<TokenIssueTransaction>;
};


/** A URL objective on a Learning Path */
export type UrlObjective = LearningObjective & Node & {
  __typename?: 'URLObjective';
  /** The number of credits that this Learning Objective represents */
  credits?: Maybe<Scalars['Int']>;
  /** The expected required time in days to complete the Learning Objective */
  expectedCompletionDays?: Maybe<Scalars['Decimal']>;
  /** The option group this objective belongs to, or null if it is not part of a group */
  group?: Maybe<LearningObjectiveGroup>;
  /** ID of the URL Objective */
  id?: Maybe<Scalars['ID']>;
  /** The order of this Learning Objective in the set of Learning Path Objectives */
  order?: Maybe<Scalars['Int']>;
  /** URL used for this Objective */
  url?: Maybe<Scalars['String']>;
};

/** The Outcome from the URL Objective */
export type UrlOutcome = LearningPathResult & Node & {
  __typename?: 'URLOutcome';
  /** Denotes whether or not the Outcome has been completed by the Learner */
  completed?: Maybe<Scalars['Boolean']>;
  /** The number of credits that the Outcome represents */
  credits?: Maybe<Scalars['Int']>;
  /** ID for the URL Outcome */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the Objective to which the Outcome refers */
  objectiveId?: Maybe<Scalars['ID']>;
  /** The order of this Outcome in the set of Learning Assignment Outcomes */
  order?: Maybe<Scalars['Int']>;
  /** URL to which the Outcome refers to */
  url?: Maybe<Scalars['String']>;
};

/** SCORM Versions */
export enum Version {
  /** SCORM Version 1.2 */
  Scorm12 = 'SCORM12',
  /** SCORM Version 2004 */
  Scorm2004 = 'SCORM2004'
}

/** Content in the form of a Video */
export type Video = Content & Node & {
  __typename?: 'Video';
  /** Flag indicating if the content should be auto completed on learner access */
  autoComplete?: Maybe<Scalars['Boolean']>;
  /** The main display name of the Content */
  displayName?: Maybe<Scalars['String']>;
  /**
   * @deprecated |||
   * |-|-:|
   * | Reason | This field does not support values larger than 2 gigabytes. Please use "fileSizeStr". |
   * | Removal Date | 2024-04-03 |
   * | Deprecation Date | 2021-08-19 |
   */
  fileSize?: Maybe<Scalars['Int']>;
  /** The size of this Video in bytes. Returned as string, to allow universal support for values larger than 2 gigabytes */
  fileSizeStr?: Maybe<Scalars['String']>;
  /** Description of the Content. Contains HTML. */
  htmlDescription?: Maybe<Scalars['String']>;
  /** ID of the Video */
  id?: Maybe<Scalars['ID']>;
  /** List of Training Pass Type IDs that grant access to this Content */
  includedInPassTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Flag indicating if the Content requires a Training Pass to access it */
  isPremium?: Maybe<Scalars['Boolean']>;
  /** Public Content can be displayed to annonymous users for free */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Content is required for the Learner to complete the Event */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The order in which the Content should be displayed */
  order?: Maybe<Scalars['Int']>;
  /** Type of the Content */
  type?: Maybe<Scalars['String']>;
  /** The ID for the video on Wistia */
  wistiaVideoId?: Maybe<Scalars['String']>;
};

/** A summary of results for a Learner on a piece of Video Content */
export type VideoContentResult = ContentResult & Node & {
  __typename?: 'VideoContentResult';
  /** The Learner attempts on the Content */
  attempts?: Maybe<Scalars['Int']>;
  /** The number of complete attempts the Learner has had on this Content */
  completedAttempts?: Maybe<Scalars['Int']>;
  /** The Content this result relates to */
  content?: Maybe<Content>;
  /** The ID to the piece of Content this result relates to */
  contentId?: Maybe<Scalars['ID']>;
  /** The ID of the Content Result */
  id?: Maybe<Scalars['ID']>;
  /** The date and time when the Content was last accessed */
  lastAccessed?: Maybe<Scalars['Datetime']>;
  /** The percentage complete the Learner has achieved on the Content */
  progress?: Maybe<Scalars['Decimal']>;
  /** The score the Learner has achieved on the Content */
  score?: Maybe<Scalars['Decimal']>;
  /** The score percent the Learner has achieved on the Content */
  scorePercent?: Maybe<Scalars['Decimal']>;
  /** The position in seconds to start playing the Video Content at, based on previous progress */
  startAt?: Maybe<Scalars['Int']>;
  /** The current status of the Content */
  status?: Maybe<ContentResultStatus>;
};

/** The current Viewer in the LMS */
export type Viewer = {
  __typename?: 'Viewer';
  /** Viewer company */
  company?: Maybe<Scalars['String']>;
  /** Viewer custom field values */
  customFieldValues?: Maybe<Array<Maybe<ViewerCustomFieldValue>>>;
  /** Viewer email address */
  emailAddress?: Maybe<Scalars['String']>;
  /** Viewer external ID names */
  externalIdNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Viewer first name */
  firstName?: Maybe<Scalars['String']>;
  /** Viewer ID */
  id?: Maybe<Scalars['ID']>;
  /** Flag indicating if the Viewer is a Coordinator */
  isCoordinator?: Maybe<Scalars['Boolean']>;
  /** Job role of the viewer */
  jobRole?: Maybe<Scalars['String']>;
  /** Viewer last name */
  lastName?: Maybe<Scalars['String']>;
  /** Flag indicating if the viewer has been shown the portal welcome message */
  learnerWelcomed?: Maybe<Scalars['Boolean']>;
  /** Viewer locale */
  locale?: Maybe<Scalars['String']>;
  /** Name of the timezone used by the Viewer */
  timeZoneName?: Maybe<Scalars['String']>;
  /** List of Training Passes assigned to the viewer */
  trainingPasses?: Maybe<Array<Maybe<TrainingPass>>>;
  /** Viewer username */
  username?: Maybe<Scalars['String']>;
};

/** Identifying information for the sign in Credentials of the Viewer */
export type ViewerCredentials = {
  __typename?: 'ViewerCredentials';
  /** The ID of the Credentials */
  id?: Maybe<Scalars['ID']>;
};

/** Mutations for Viewer Credentials */
export type ViewerCredentialsMutations = {
  __typename?: 'ViewerCredentialsMutations';
  /** Marks the Viewer as welcomed by the portal */
  markLearnerWelcomed?: Maybe<ViewerCredentialsMutationsResponseType>;
  /** Sets the password */
  setPassword?: Maybe<ViewerCredentialsMutationsResponseType>;
};


/** Mutations for Viewer Credentials */
export type ViewerCredentialsMutationsSetPasswordArgs = {
  input?: Maybe<SetPasswordInputType>;
};

/** A response from mutating Viewer Credentials */
export type ViewerCredentialsMutationsResponseType = {
  __typename?: 'ViewerCredentialsMutationsResponseType';
  /** The errors returned by the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The Credentials that was mutated */
  viewerCredentials?: Maybe<ViewerCredentials>;
};

/** A value stored for a Custom Field */
export type ViewerCustomFieldValue = {
  __typename?: 'ViewerCustomFieldValue';
  /** The identifier of the Custom Field */
  key?: Maybe<Scalars['String']>;
  /** The human readable definition locator of the Custom Field */
  locator?: Maybe<Scalars['String']>;
  /** Returns the related entity field value */
  value?: Maybe<Scalars['String']>;
};

/** The Response from mutating a Viewer */
export type ViewerMutateResponseType = {
  __typename?: 'ViewerMutateResponseType';
  /** Errors from the mutation */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** The mutated Viewer */
  viewer?: Maybe<Viewer>;
};

/** Viewer Mutations */
export type ViewerMutations = {
  __typename?: 'ViewerMutations';
  /** Update the current Viewer */
  update?: Maybe<ViewerMutateResponseType>;
};


/** Viewer Mutations */
export type ViewerMutationsUpdateArgs = {
  input: ViewerUpdateInput;
};

/** An Input to update the current logged in User */
export type ViewerUpdateInput = {
  /** Custom Field Values */
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValueInputType>>>;
  /** The Job Role */
  jobRole?: Maybe<Scalars['String']>;
  /** The Locale */
  locale?: Maybe<Scalars['String']>;
  /** The Personal Name */
  personalName?: Maybe<PersonalNameInputType>;
  /** The Time Zone Name */
  timeZoneName?: Maybe<Scalars['String']>;
};

/** Settings used by a WebLink Portal to handle approval payments */
export type WebLinkApprovalPaymentProvider = WebLinkPaymentProvider & {
  __typename?: 'WebLinkApprovalPaymentProvider';
  /** The Opportunity Step for a newly created approval request */
  approvalEntryStep?: Maybe<OpportunityStep>;
  /** The list of Opportunity steps that this request must go through in order to be approved */
  approvalSignOffSteps?: Maybe<Array<Maybe<OpportunityStep>>>;
  /**
   * The Payment Method Type that will be used to classify payments made using this
   * Payment Provider on Invoices created via WebLink Orders
   */
  paymentMethod?: Maybe<PaymentMethodType>;
  /** The Opportunity Step that indicates this request for approval was approved */
  requestApprovedStep?: Maybe<OpportunityStep>;
  /** The Opportunity Step that indicates this request for approval is on a waitlist */
  requestOnWaitlistStep?: Maybe<OpportunityStep>;
  /** The Opportunity Step that indicates this request for approval was rejected */
  requestRejectedStep?: Maybe<OpportunityStep>;
};

/** Settings used by a WebLink Portal to take payments by Invoice */
export type WebLinkInvoicePaymentProvider = WebLinkPaymentProvider & {
  __typename?: 'WebLinkInvoicePaymentProvider';
  /** The Name of this Payment Provider */
  name?: Maybe<Scalars['String']>;
  /** The opportunity step at which this payment method becomes active */
  opportunityStep?: Maybe<OpportunityStep>;
  /**
   * The Payment Method Type that will be used to classify payments made using this
   * Payment Provider on Invoices created via WebLink Orders
   */
  paymentMethod?: Maybe<PaymentMethodType>;
};

/** Settings used to configure the payment settings for a Weblink Portal */
export type WebLinkPaymentProvider = {
  /**
   * The Payment Method Type that will be used to classify payments made using this
   * Payment Provider on Invoices created via WebLink Orders
   */
  paymentMethod?: Maybe<PaymentMethodType>;
};

/** A separate portal that Contacts can access to purchase or register onto training */
export type WebLinkPortal = {
  __typename?: 'WebLinkPortal';
  /** The ID of this Portal */
  id?: Maybe<Scalars['ID']>;
  /** Dictates if Booking Portal behaviours are enabled for this Portal */
  isBookingPortal: Scalars['Boolean'];
  /** Dictates if Self-Registration behaviours are enabled for this Portal */
  isSelfRegistrationPortal: Scalars['Boolean'];
  /** Configured Providers that can be used to take payment in this WebLink Portal */
  paymentProviders?: Maybe<Array<Maybe<WebLinkPaymentProvider>>>;
  /** Whether the Portal will show any private training (such as Private Events) available to the User via their Account. */
  showPrivateTraining: Scalars['Boolean'];
  /** The URL of this Portal */
  url?: Maybe<Scalars['String']>;
};

/** Settings used by a WebLink Portal to take payments with Stripe */
export type WebLinkStripePaymentProvider = WebLinkPaymentProvider & {
  __typename?: 'WebLinkStripePaymentProvider';
  /** The Name of this Payment Provider */
  name?: Maybe<Scalars['String']>;
  /**
   * The Payment Method Type that will be used to classify payments made using this
   * Payment Provider on Invoices created via WebLink Orders
   */
  paymentMethod?: Maybe<PaymentMethodType>;
  /** The Public Key provided by Stripe to make a charge */
  stripePublicKey?: Maybe<Scalars['String']>;
  /** The Secret Key provided by Stripe to make a charge */
  stripeSecretKey?: Maybe<Scalars['String']>;
};

/** Use the Payment Provider from the Linked WebLink Portal instead */
export type WebLinkUnsupportedPaymentProvider = WebLinkPaymentProvider & {
  __typename?: 'WebLinkUnsupportedPaymentProvider';
  /** The Name of this Payment Provider */
  name?: Maybe<Scalars['String']>;
  /**
   * The Payment Method Type that will be used to classify payments made using this
   * Payment Provider on Invoices created via WebLink Orders
   */
  paymentMethod?: Maybe<PaymentMethodType>;
};

/** A message to be displayed to Learners when first accessing the Portal */
export type WelcomeMessage = {
  __typename?: 'WelcomeMessage';
  /** The body of the Welcome Message */
  body?: Maybe<Scalars['String']>;
  /** The dismiss button text */
  buttonText?: Maybe<Scalars['String']>;
  /** The URL of the image used in the Welcome Message */
  imageUrl?: Maybe<Scalars['String']>;
};
